<template>
  <div class="fusion-metadata-view-root">
    <ImagePreviewDialog class="hide-element-util-mount" v-cloak :selectedFile="selectedFileInfo" @closeMiniPlayer="showOtherFilesPreviewDialog = false" v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
    <!-- <div v-if="focusMode" class="focusBadge">Focus AI</div> -->
    <div v-if="vdialogComponents.includes(openTagMetadataModel)">
      <component
        :is="openTagMetadataModel"
        v-bind="currentProperties"
        v-if="isMetadataManagerVisible"
        @close="closeModal"
        @openSubclipWindowInMetadataView="openSubclipWindowInMetadataView"
        @openVideoTranscriptWindow="openVideoTranscriptWindow"
        @assetSelectionUpdated="handleAssetVersionUpdate"
        @handleFilesBrowse="handleFusionBrowsedFiles"
        @uploadSvgIconAsCover="uploadSvgIconAsCover"
        :ref="'modal'+openTagMetadataModel"
      ></component>
    </div>
    <div v-else>
      <router-view
        :name="openTagMetadataModel"
        v-bind="currentProperties"
        v-if="isMetadataManagerVisible"
        @close="closeModal"
        @openSubclipWindowInMetadataView="openSubclipWindowInMetadataView"
        @openVideoTranscriptWindow="openVideoTranscriptWindow"
        @assetSelectionUpdated="handleAssetVersionUpdate"
        :ref="'modal'+openTagMetadataModel"
        @AIComponentNavigation="traverseToAIComp"
      ></router-view>
    </div>
    <section class="split" ref="split" :style="splitStyles">

      <!-- Panel 1: Catalog -->
      <div class="panel">
        <div class="panelHeader">
            <div class="subtitle"><top-nav
              @columns-updated="handleMetadataViewColumnsUpdated"
              @changeComponent="changeComponent"
              @changeDirectoryFromUrl="changeCatalog"
              :getCookieValueOfJobPanel="getCookieValueOfJobPanel"
              compoentType="CatalogWorkspace"
              :usedBy="workspace && workspace == 'Projects'?rootCatalogInfo.catalog_name:'Catalogs'"
              :dirs="dirs"
              :metadataView="true"
              ref="top_nav_bar"
              :sortedOption="sortBy"
              v-on:sort-by-filter-updated="sortCatalogTable"
              @fileStateFilterUpdated="updateFileStateFilter"
              @reloadThePage="reloadThePage"
              @changeJobsPanelState="changeJobsPanelState"
              :workspace="workspace"
              :rootCatalogInfo="rootCatalogInfo"></top-nav></div>
          <!-- <div class="right">⋮</div> -->
        </div>

            <div class="panelBody m-0 p-0 h-100">
              <div style="height:100%" @click="deselectFileAndContextMenu" @contextmenu="show($event, selectedFileInfo)" :ripple="false" data-app>
                <div style="height: calc(100% - 50px);overflow: auto;padding:12px">
                  <div v-if="effectiveChildren.filter(op=>(!('catalog_type' in op) || (!['photo_album','package'].includes(op.catalog_type)))).length" class="catalogs-workspace-sections">
                    <!-- <div class="crumb">Catalogs</div> -->
                    <div class="grid2">
                      <drag-select-container style="display:contents" attribute="attr" @change="dragSelect($event)">
                        <div 
                        v-for="catalog in effectiveChildren.filter(op=>(!('catalog_type' in op) || (!['photo_album','package'].includes(op.catalog_type))))"
                        :key="catalog._id"
                        :attr="catalog._id"
                        @click.exact="selectElement($event,catalog)"
                        :class="{ active: isFileSelected(catalog) , 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE'}"
                        @click.ctrl="multiSelectElemet(catalog)"
                        @dblclick="showCatalogDetails(catalog)"
                        @contextmenu.stop.prevent="show($event, catalog)"
                        :ripple="false"
                        :title="catalog.catalog_name"
                        data-app
                        class="cardMini"
                      >
                        <!-- <div class="k">Catalog</div> -->
                        <div class="card-catalog-or-asset">
                          <div :class="catalog.asset_state == 'MARK FOR DELETE'?'reduce-opacity':' '">
                              <template v-if="'catalog_cover_photo_path' in catalog && catalog.catalog_cover_photo_path.trim().length > 0">
                                <div class="card" style="width: 15px; height: 15px; top:3px; overflow: hidden; display: flex; background-color: transparent;">
                                  <img class="card-img-top" :src="getCatalogCoverPhoto(catalog)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;background-color: transparent">
                                </div>
                              </template>
                              <div v-else-if="'catalog_cover_photo_file_uid' in catalog && catalog.catalog_cover_photo_file_uid.trim().length > 0 && catalog.catalog_cover_photo_file_uid.startsWith('svg-')" style="height: 15px;width: 15px;" v-html="getSvgIconForCoverPhoto(catalog.catalog_cover_photo_file_uid.split('svg-')[1])"></div>
                              <svg v-else xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                              </svg>
                            <img v-if="catalog.asset_state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: absolute;inset-inline-start : -2px;">
                          </div>
                          <div class="catalog-name">
                            {{ catalog.catalog_name }}
                          </div>
                        </div>
                        </div>
                      </drag-select-container>
                    </div>
                  </div>

                  <div v-if="effectiveChildren.filter(op=>('catalog_type' in op && op.catalog_type == 'photo_album')).length" class="catalogs-workspace-sections" style="padding-top:10px">
                    <div class="crumb">{{$t('Photo Albums')}}</div>
                    <div class="grid2" style="display: flex;flex-wrap: wrap;">
                      <drag-select-container style="display:contents" attribute="attr" @change="dragSelect($event)">
                        <div 
                          v-for="catalog in effectiveChildren.filter(op=>('catalog_type' in op && op.catalog_type == 'photo_album'))"
                          :key="catalog._id"
                          :attr="catalog._id"
                          @click.exact="selectElement($event,catalog)"
                          :class="{ active: isFileSelected(catalog) , 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE'}"
                          @click.ctrl="multiSelectElemet(catalog)"
                          @dblclick="showCatalogDetails(catalog)"
                          @contextmenu.stop.prevent="show($event, catalog)"
                          :ripple="false"
                          :title="catalog.catalog_name"
                          data-app
                          style="position: relative;height:auto;width:auto;padding-inline-start:0px"
                          >
                          <!-- <div class="k">Catalog</div> -->
                          <div class="card-catalog-or-asset">
                              <div class="asset-thumbnail mv-album-thumb" style="height: 110px !important;margin-top:0px">
                              <div class="card" style="width: 110px; height: 100%; overflow: hidden; display: flex; background-color: rgb(45, 57, 60); border: 1px solid rgb(58, 58, 58);border-radius: 7px;">
                                <img class="card-img-top" :src="getCatalogCoverPhoto(catalog)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;">
                                <div class="card-body mv-album-overlay" style="width: inherit; display: flex; align-items: center; padding: 0px 7px 0px 7px; position: absolute; background-color: rgba(3, 4, 4, 0.7);border-radius: 0px 0px 7px 7px;bottom:0px">
                                  <div style="width:100%;display:inline-block;text-align:start">
                                    <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap; width: 100%; display: block;" :title="catalog.catalog_name">
                                      <div  v-if="catalog.highlight && catalog.highlight['catalog_name']" class="transcript-content-wrapper"
                                      style="display:flex;width: 100%; align-items: flex-start;font-weight:700">
                                        <div style="flex: 1;">
                                          <span v-for="(cContent,index) in catalog.highlight['catalog_name']" :key="'catalog_name'+index" v-html="getTranscriptHighlightContent(cContent)"  class="transcript-content-highlight" style="white-space: pre-wrap;"></span>
                                        </div>
                                      </div>
                                      <span v-else>{{catalog.catalog_name}}</span>
                                    </div>
                                    <div style="width:100%;font-size: 11px;display:inline-flex;color:#adadad;flex-direction:column">
                                      <template v-if="'album_assets_count' in catalog && catalog.album_assets_count > 0">
                                        <div v-if="catalog.album_assets_count > 1" style="width:50%">{{catalog.album_assets_count}} {{$t('files')}}</div>
                                        <div v-else-if="catalog.album_assets_count <= 1" style="width:50%">{{catalog.album_assets_count}} {{$t('file')}}</div>
                                      </template>
                                      <div v-else style="width:50%">0 {{$t('files')}}</div>
                                      <div :title="getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime:catalog.asset_created_datetime)">{{getDateAndTimeInConfiguredFormat(catalog.created_datetime? catalog.created_datetime:catalog.asset_created_datetime, true)}}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div v-if="catalog.asset_state == 'GROWING'">
                                <img :src="growingFileGif"
                                      alt="loading"
                                      style="height:50px;width:65px;position:absolute;bottom:40%;inset-inline-start:28%"
                                    />
                              </div>
                              <div v-else-if="catalog.state == 'ERROR'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#af0000" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="position:absolute;bottom:49%;inset-inline-start:41%">
                                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                                  <title>{{$t('ERROR')}}</title>
                                </svg>
                              </div>
                              <div v-else-if="catalog.asset_state == 'MARK FOR DELETE'">
                                <img
                                  :src="markForDeleteIcn"
                                  alt="markfordelete"
                                  style="height:25px;width:29px;position:absolute;bottom:47%;inset-inline-start:42%"
                                  />
                              </div>
                              <div v-if="eOMenu || !['GROWING'].includes(catalog.asset_state)"
                                  class="shortcut-actions-type-icons-wrapper" style="z-index:2;" :class="eOMenu?'overWriteShortcutIconWrapper':''">
                                <div class="overflow-parent-div">
                                  <svg @click.stop.prevent="eOMenu=true;selectElement($event,catalog,false);show($event, selectedFileInfo)" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                    <title>{{$t('More actions')}}</title>
                                    <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                  </svg>
                                </div>
                              </div>
                              </div>
                          </div>
                        </div>
                      </drag-select-container>
                    </div>
                  </div>
                  <div v-if="effectiveChildren.filter(op=>(('catalog_type' in op) && (['package'].includes(op.catalog_type)))).length" class="catalogs-workspace-sections"  style="padding-top:10px">
                    <div class="crumb">{{$t('Packages')}} </div>
                      <div class="grid2">
                        <drag-select-container style="display:contents" attribute="attr" @change="dragSelect($event)">  
                          <div 
                              v-for="catalog in effectiveChildren.filter(op=>(('catalog_type' in op) && (['package'].includes(op.catalog_type))))"
                              :key="catalog._id"
                              :attr="catalog._id"
                              @click.exact="selectElement($event,catalog)"
                              :class="{ active: isFileSelected(catalog) , 'reduce-opacity': catalog.asset_state == 'MARK FOR DELETE'}"
                              @click.ctrl="multiSelectElemet(catalog)"
                              @dblclick="showCatalogDetails(catalog)"
                              @contextmenu.stop.prevent="show($event, catalog)"
                              :ripple="false"
                              :title="catalog.catalog_name"
                              data-app
                              class="cardMini"
                            >
                            <div class="card-catalog-or-asset">
                                <div class="folder-view" :class="catalog.asset_state == 'MARK FOR DELETE'?'reduce-opacity':' '">
                                  <template v-if="'catalog_cover_photo_path' in catalog && catalog.catalog_cover_photo_path.trim().length > 0">
                                    <div class="card" style="width: 34px; height: 78%; top:6px; overflow: hidden; display: flex; background-color: transparent;border-radius: 7px;">
                                      <img class="card-img-top" :src="getCatalogCoverPhoto(catalog)" @error="(e) => replaceByDefaultImage(e,null)" alt="Card image cap" style="height: 100%;max-width: inherit;max-height: inherit;width: inherit;object-fit: cover;background-color: transparent">
                                    </div>
                                  </template>
                                  <div v-else-if="'catalog_cover_photo_file_uid' in catalog && catalog.catalog_cover_photo_file_uid.trim().length > 0 && catalog.catalog_cover_photo_file_uid.startsWith('svg-')" style="height: 30px;width: 30px;" v-html="getSvgIconForCoverPhoto(catalog.catalog_cover_photo_file_uid.split('svg-')[1])"></div>
                                  <!-- <svg v-else xmlns="http://www.w3.org/2000/svg" width="1eplayer-current-time-divisionm" height="1em" fill="#5f777d" class="bi bi-folder-fill" viewBox="0 0 16 16">
                                    <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                                  </svg> -->
                                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="#5f777d" class="bi bi-collection-fill" viewBox="0 0 16 16">
                                    <path d="M0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6zM2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3m2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1"/>
                                  </svg>
                                <img v-if="catalog.asset_state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;inset-inline-end :50%;">
                              </div>
                              <div class="catalogs-data">
                                {{ catalog.catalog_name }}
                              </div>
                            </div>
                          </div>
                        </drag-select-container>
                      </div>
                  </div>
                  <div style="margin-top:14px;color:var(--muted);font-size:12px;display:flex;align-items:center;justify-content:space-between;">
                    <span>{{$t('Files')}}</span><span>{{ effectiveAssets.length }} {{$t('records')}}</span>
                  </div>  
                  <div class="files">
                    <drag-select-container attribute="attr" @change="dragSelect($event)">
                      <div 
                        class="fileRow" 
                        v-for="file in effectiveAssets"
                        :key="file._id"
                        :attr="file._id"
                        @click.exact="selectElement($event,file,true,true)"
                        @click.ctrl="multiSelectElemet(file)"
                        @dblclick.stop.prevent="showAssetPreview(file)"
                        :class="{ active: isFileSelected(file) }"
                        @contextmenu.stop.prevent="show($event, file)" :ripple="false" data-app
                        style="position:relative"
                        :title="getFileName(file)"
                        @mousemove="handleMouseMoveForStoryBoardPreview($event,file)"
                        @mouseleave="storyboardPreviewActiveId = null"
                      >
                      <div v-if="eOMenu || !['GROWING'].includes(file.state)" class="shortcut-actions-type-icons-wrapper" :class="eOMenu?'overWriteShortcutIconWrapper':''" style="z-index:2;">
                        <template v-if="!['MARK FOR DELETE'].includes(file.state)  &&
                                            !['no-access','browse'].includes(file.permissions) &&
                                            (Object.keys(selectedFileInfo).length >= 1 || Object.keys(selectedFiles).length == 1 ||
                                                Object.keys(selectedFileInfo).length <= 0 && Object.keys(selectedFiles).length <= 0 ||
                                                  !isFileSelected(file))">
                          <svg v-if="!lockRestrictedAction('Download', file) && isFileActionEnabled('Download',file.permissions) && !['GROWING','MARK FOR DELETE'].includes(file.state)" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-download" viewBox="0 0 16 16">
                            <title>{{$t('Download')}}</title>
                            <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                            <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                          </svg>
                          <svg v-if="!lockRestrictedAction('Chat', file) && file.asset_type == 'subclip' && isFileActionEnabled('Chat',file.permissions)" @click="shareInChatSubclips(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-dots-fill" viewBox="0 0 16 16">
                            <title>{{$t('Share in chat')}}</title>
                            <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                          </svg>
                          <svg v-if="!lockRestrictedAction('Share', file) && file.asset_type != 'subclip' && isFileActionEnabled('Share',file.permissions) && !['GROWING','MARK FOR DELETE'].includes(file.state)" @click="handleShareAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-share-fill" viewBox="0 0 16 16">
                            <title>{{$t('Share')}}</title>
                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                          </svg>
                          <svg v-if="!lockRestrictedAction('tag-metadata',file) && isFileActionEnabled('tag-metadata',file.permissions) && !['GROWING','MARK FOR DELETE'].includes(file.state)" @click="handleTagMetadataAssetHoverAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-tag-fill" viewBox="0 0 16 16">
                            <title>{{$t('Tag Metadata')}}</title>
                            <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                          </svg>
                        </template>
                        <svg v-if="!lockRestrictedAction('Preview', file)" @click="showAssetPreview(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#928f8f">
                          <path d="M0 0h24v24H0V0z" fill="none"/>
                          <title>{{$t('Preview')}}</title>
                          <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                        </svg>
                        <div class="overflow-parent-div">
                          <svg @click.stop.prevent="eOMenu=true;selectElement($event,file,false);show($event, selectedFileInfo)" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                            <title>{{$t('More actions')}}</title>
                            <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                          </svg>
                          <!-- <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                <div class="dropdown-item p-2 copy-link-action" @click="setClipBoardText(file)" title="Copy link">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fdfff4" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                      <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                      <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                  </svg>
                                  Copy link</div>
                                  <div v-if="isEnabled('Chat')" class="dropdown-item p-2 copy-link-action" @click="openShareInChat()" title="">
                                    <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-share-fill" viewBox="0 0 16 16">
                                      <title></title>
                                      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                                    </svg>
                                    Share in chat</div>
                          </div> -->
                        </div>
                      </div>
                        <div class="thumb" :data-thumbnailwrapperid="file._id">
                          <StoryBoardImagePreview :ref="'storyboard'+file._id" v-if="getFileMimeType(file) == 'video' && storyboardPreviewActiveId == file._id" :assetDetails="file"></StoryBoardImagePreview>
                          <div class="metadata-view-thumbnail" :class="file.asset_state == 'MARK FOR DELETE' || file.state == 'ERROR'?'reduce-opacity':' '">
                            <img :src="getThumbnailPath(file,'FOR_SVG_THUMBNAIL')" @error="(e) => replaceByDefaultImage(e,file,'FOR_SVG_THUMBNAIL')" alt="image" draggable="false" />
                            <img v-if="file.asset_state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 32px;width: 32px;position: absolute;top: 34px;inset-inline-start :10px;">
                            <div v-if="file.asset_state == 'GROWING'">
                              <img :src="growingFileGif"
                                    alt="loading"
                                    style="height:50px;width:65px;position:absolute;bottom:23%;inset-inline-start:-19%"
                                  />
                            </div>
                          </div>
                        </div>
                        <div class="fileMeta">
                          <div class="name" :title="getFileName(file)" v-if="!getHighlightFilename(file,getFileName(file)).highlight" style="display:flex">
                            <span class="dynamic-slug-name">{{ getFileName(file) }}</span>
                            <span class="file-extension-thumbnail-view" v-if="barcodeInfoFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
                          </div>
                          <div class="name" :title="getFileName(file)" v-else :style="barcodeInfoFromStartup.enable_file_extension?'':'max-width:140px !important'" style="display:flex;">
                            <span class="dynamic-slug-name" v-html="getHighlightFilename(file,getFileName(file)).slugname"></span>
                            <span class="file-extension-thumbnail-view" v-if="barcodeInfoFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
                          </div>
                          <div class="small asset-meta-row">
                            <template v-if="checkIfDisabled(file) && getReadableResolutionValue(file)">
                              <span :id="'assetResolution_'+file._id" class="resolution-badge asset-meta-item">
                                {{ getReadableResolutionValue(file) }}
                              </span>
                            </template>
                          
                            <template v-if="'mime_type' in file && file.mime_type && (file.mime_type.startsWith('video') || file.mime_type.startsWith('audio')) && 'duration' in file && file.duration">
                              <span class="asset-meta-item">
                                {{ getHumanReadableDuration(file.duration) }}
                              </span>
                            </template>
                          
                            <template v-if="file.asset_state != 'MARK FOR DELETE' && Object.keys(file).includes('asset_ttl') && file.asset_ttl">
                              <span v-if="loadTTLIcons(file.asset_ttl)" class="asset-meta-item">
                                <span v-html="loadTTLIcons(file.asset_ttl)" style="width: 22px; display: inline-flex;"></span>
                              </span>
                            </template>
                          
                            <template v-if="file.subclips_present == true">
                              <span class="asset-meta-item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                  <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                  <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                  <title>{{$t('Have subclips')}}</title>
                                </svg>
                              </span>
                            </template>
                          
                            <template v-if="'asset_lock' in file && file.asset_lock">
                              <span class="asset-meta-item">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18" height="18" style="position: relative; top: -1px;">
                                  <path fill="#cdcdcd" d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z"></path>
                                  <path fill="#e98405" d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z"></path>
                                  <path fill="#55524e" d="M24 28A3 3 0 1 0 24 34A3 3 0 1 0 24 28Z"></path>
                                  <title>{{$t('Locked')}}</title>
                                </svg>
                              </span>
                            </template>
                          
                            <template v-if="file.asset_type == 'subclip'">
                              <span class="asset-meta-item">
                                <span style="position:relative; inset-inline-start:4px; width:30px; display:inline-flex;">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                    <title>{{$t('Subclip')}}</title>
                                  </svg>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute; inset-inline-end :6px; top:1px">
                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                    <title>{{$t('Subclip')}}</title>
                                  </svg>
                                </span>
                              </span>
                            </template>
                          
                            <template v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier')">
                              <span class="asset-meta-item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Glacier')}}</title>
                                </svg>
                              </span>
                            </template>
                          
                            <template v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Deep Archive')">
                              <span class="asset-meta-item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Glacier Deep Archive')}}</title>
                                </svg>
                              </span>
                            </template>
                          
                            <template v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')">
                              <span class="asset-meta-item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Glacier Instant Retrieval')}}</title>
                                </svg>
                              </span>
                            </template>
                          
                            <template v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Standard')">
                              <span class="asset-meta-item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Standard')}}</title>
                                </svg>
                              </span>
                            </template>
                          
                            <template v-if="Object.keys(file).includes('archived') && file.archived">
                              <span class="asset-meta-item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16">
                                  <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                                  <title>{{$t('Archived')}}</title>
                                </svg>
                              </span>
                            </template>
                          
                            <template v-if="'location_info' in file && 'gravity_deep' in file.location_info">
                              <span v-for="cId of file.location_info.gravity_deep.container_ids" :key="cId" class="asset-meta-item">
                                <svg v-if="cId == 'CACHE'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-c-square" viewBox="0 0 16 16">
                                  <title>{{ cId }}</title>
                                  <path d="M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"/>
                                  <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a1 1 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"/>
                                </svg>
                          
                                <svg v-else-if="cId && cId.startsWith('Tape')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cassette-fill" viewBox="0 0 16 16">
                                  <title>{{ cId }}</title>
                                  <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"/>
                                  <path d="m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"/>
                                </svg>
                          
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                                  <title>{{ cId }}</title>
                                  <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                                </svg>
                              </span>
                            </template>
                          
                            <template v-if="file.location_info && Object.keys(file.location_info).includes('alto')">
                              <span class="asset-meta-item">
                                <img title="ALTO" :src="altoLogo" alt="alto" style="height:16px;width:16px"/>
                              </span>
                            </template>
                          </div>
                          <div
                          v-if="enabledMetadataColumns && enabledMetadataColumns.length"
                          class="metadata-view-configured-columns-row"
                        >
                          <span
                            v-for="column in enabledMetadataColumns"
                            :key="'metadata_view_column_' + file._id + '_' + column._id"
                            class="metadata-view-configured-column-chip"
                            v-show="getMetadataColumnValue(file, column) && getMetadataColumnValue(file, column) !== '-'"
                            :class="{
                              'metadata-view-configured-column-chip--multiline': isMetadataMultiline(file, column),
                              'metadata-view-configured-column-chip--freetext-multivalue': column.type === 'FREETEXT_MULTILINE'
                            }"
                            :title="column.name + ': ' + getMetadataColumnValue(file, column)"
                          >
                            <span class="metadata-view-configured-column-name">
                              {{ column.name }}:
                            </span>
                        
                            <template v-if="isMetadataMultiline(file, column) || column.type === 'FREETEXT_MULTILINE'">
                              <span class="metadata-view-multiline-wrapper">
                                <span
                                  class="metadata-view-configured-column-value metadata-view-multiline-value"
                                  :class="{ expanded: isMultilineExpanded(file, column) }"
                                >
                                  <template v-if="getMetadataHighlight(file, column)">
                                    <span v-html="getMetadataHighlight(file, column)"></span>
                                  </template>
                        
                                  <template v-else>
                                    {{ getMetadataColumnValue(file, column) }}
                                  </template>
                                </span>
                        
                                <button
                                  v-if="
                                    shouldShowMultilineToggle(file, column) ||
                                    (
                                      column.type === 'FREETEXT_MULTILINE' &&
                                      String(getMetadataColumnValue(file, column) || '').length > 45
                                    )
                                  "
                                  type="button"
                                  class="metadata-view-show-more-btn"
                                  @click.stop.prevent="toggleMultilineExpand(file, column)"
                                >
                                  {{ isMultilineExpanded(file, column) ? $t('see less') : $t('see more') }}
                                </button>
                              </span>
                            </template>
                        
                            <template v-else>
                              <span class="metadata-view-configured-column-value">
                                <template v-if="getMetadataHighlight(file, column)">
                                  <span v-html="getMetadataHighlight(file, column)"></span>
                                </template>
                        
                                <template v-else>
                                  {{ getMetadataColumnValue(file, column) }}
                                </template>
                              </span>
                            </template>
                          </span>
                        </div>
                        </div>
                      </div>
                    </drag-select-container>
                  </div>
                </div>
                <div style="display: inline-flex;width:100%;position:relative;top:8px;justify-content: end;">
                  <div>
                    <pagination
                      v-if="effectiveTotalAssets > -1"
                      v-model="page"
                      :records="effectiveTotalAssets"
                      :per-page="effectiveAssetsPerPage"
                      @paginate="paginate"
                      :options="options"
                    />
                  </div>
                </div>
              </div>
            </div>
        </div>

      <!-- Resizer 1 -->
      <div 
        class="resizer" 
        :class="{ active: activeResizer === 1 }"
        @mousedown="startDrag(1, $event)"
        title="Drag to resize"
      ></div>

      <!-- Panel 2: Player + Quick Metadata -->
      <div class="panel">
        <div class="panelHeader">
          <div class="title">{{$t('Player')}}</div>
          <div class="right">
          </div>
        </div>
        <div class="panelBody">
          <div class="playerWrap">
            <div class="player" style="position:relative" aria-label="Video Player Mock">
              <button  v-if="!getAssetDetails || Object.keys(getAssetDetails).length == 0" class="vp-play" type="button" aria-label="Play">
                <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
                  <path d="M8 5v14l11-7z" fill="currentColor"></path>
                </svg>
              </button>
              <template v-if="isVideoFile">
                  <div style="height:100%;width:100%">
                      <video-player v-if="isPlayerCanBeLoaded"  :frameRate="frameRate" :isCurrentTimeUpdateRequired="true" :isProgressbarRequired="true" ref="videoPlayerEl" id="video-player-id" @metaDataLoaded="playerFullyLoaded('videoPlayerEl','video')" @controller="setController" :options="videoOptions" style="height:100%;width:100%"/>
                  </div>
              </template>
              <customAudioPlayer :key="getAssetDetails._id" @stopPlaying="isPlaying = false" @playerPaused="isPlaying = false" @audioStartedPlaying="isPlaying = true" ref="audioPlayerRef"  :isPlayButtonRequired="false" v-if="isAudioFile" :fileInfo="getAssetDetails" :subclipDetails="subclipDetails" style="bottom: 19px;border-radius:0px !important;" class="audio-player" :isBorderRequired="false"></customAudioPlayer>
              <img v-if="isImageFile" :style="isAudioFile ? 'padding:46px;':''"  :src="getThumbnailPath(getAssetDetails)" @error="replaceByDefaultImage" style="max-width:100%;max-height:100%;object-fit:contain">
              <div v-if="isImageFile" title="Preview" @click="showAssetPreview()" class="preview-the-image">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-fullscreen" viewBox="0 0 16 16">
                  <path d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5M.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5"></path>
                </svg>
              </div>
            </div>
              <div  :style="(isVideoFile || isAudioFile) ? 'display: flex; justify-content: space-between;align-items: center;height:37px !important;': 'display: flex; justify-content: end; align-items: center;height: 37px;'">
                <div class="metadata_view_main_window_palyer_icons_wrapper" v-if="isVideoFile || isAudioFile">
                  <ul>
                      <li class="chip" title="Toggle Play-Pause (spacebar)"><button style="display: flex; align-items: center;justify-content:center;" class="btn btn-outline-secondary play common-markinmarkout-action-btn" @click="playPauseToggle()">  <span v-show="isPlaying" class="common-play-pause"><svg style="width:18px;height:18px" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg></span><span v-show="!isPlaying" class="common-play-pause"><svg  style="width:18px;height:18px;;margin-top:1px !important" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"/></svg><span style="visibility:hidden;"></span></span> </button></li>
                      <li class="chip" title="Backward 1 Second (9)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoBy1Sec('backward')">-1S</button></li>
                      <li class="chip" title="Forward 1 Second (0)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoBy1Sec('forward')">+1S</button></li>
                      <li class="chip" v-if="!isAudioFile" title="Backward 1 Frame (-)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoByFrame('backward')">-1F</button></li>
                      <li class="chip" v-if="!isAudioFile" title="Forward 1 Frame (=)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoByFrame('forward')">+1F</button></li>
                      <li class="chip" title="Fast Forward" style="margin-inline-end:6px;"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="updateFastwardValue('forward')" style="width:50px;">FF</button></li>
                      <li class="chip" v-if="currentVideoSpeed != 1" style="display: flex;align-items: center;color: #bcbcbc;margin-inline-start: 3px;">
                          <span style="border: 1px solid rgb(74, 74, 74) !important; border-radius: 15px !important; width: 32px; padding: 4px; text-align: center; background: rgb(40, 45, 49) !important; height: 20px; justify-content: center; display: flex; align-items: center; font-size: 13px;">{{currentVideoSpeed}}x</span>
                      </li>
                  </ul>
                  <!-- <div class="comm-forward-icon" v-if="currentVideoSpeed != 1" style="height:100%;" @click="resetVideoSpped">
                      <button class="btn btn-outline-secondary common-markinmarkout-action-btn" style="padding: 5px 23px;">X</button>
                  </div> -->
                </div>
            </div>
          </div>

          <div v-if="getAssetDetails && Object.keys(getAssetDetails).length > 0" class="quickMeta">
            <div v-if="getFileName(getAssetDetails)" :title="getFileName(getAssetDetails)" class="qmHead">
              <div
                class="qmTitle"
                :class="{ expandedFileName: showFullFileName }"
                @click="showFullFileName = !showFullFileName"
              >
                {{ getFileName(getAssetDetails) }}
              </div>
          
              <button
                type="button"
                class="copyFileNameBtn"
                @click.stop="copyFileName(getFileName(getAssetDetails))"
                title="Copy file name"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M10 1.5H3A1.5 1.5 0 0 0 1.5 3v9A1.5 1.5 0 0 0 3 13.5h7A1.5 1.5 0 0 0 11.5 12V3A1.5 1.5 0 0 0 10 1.5zm0 1A.5.5 0 0 1 10.5 3v9a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h7z"/>
                  <path d="M5 4.5A1.5 1.5 0 0 1 6.5 3h6A1.5 1.5 0 0 1 14 4.5v8a1.5 1.5 0 0 1-1.5 1.5H12v-1h.5a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5V5H5v-.5z"/>
                </svg>              
              </button>
            </div>
          

            <div class="qmGrid">
              <div v-if="getFileNameForDetails(getAssetDetails)" class="kv">
                <div class="k">{{$t('Filename')}}</div>
                <div class="card-catalog-or-asset">{{ getFileNameForDetails(getAssetDetails) }}</div>
              </div>
              <div v-if="getAssetDetails.storage_class" class="kv">
                <div class="k">{{$t('Location')}}</div>
                <div class="card-catalog-or-asset"><div v-for="storageClass in getAssetDetails.storage_class" class="d-inline-flex" style="align-items:center" :key="storageClass">
                    <svg v-if='storageClass == "Disk"' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(getAssetDetails.location_info,storageClass)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                      </svg>
                      <span style="margin-inline-start:4px">{{ storageClass }}</span>
                </div>
              </div>
              </div>
              <div v-if="getDateAndTimeInConfiguredFormat(getAssetDetails.added_datetime)" class="kv">
                <div class="k">{{$t('Date Added')}}</div>
                <div class="card-catalog-or-asset">{{ getDateAndTimeInConfiguredFormat(getAssetDetails.added_datetime) }}</div>
              </div>
              <div  v-if="'mime_type' in getAssetDetails && getAssetDetails.mime_type && getAssetDetails.mime_type.startsWith('video') &&
              'duration' in getAssetDetails && getAssetDetails.duration" class="kv">
                <div class="k">{{$t('Duration')}}</div>
                <div class="card-catalog-or-asset">{{ getHumanReadableDuration(getAssetDetails.duration) }}</div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state">            
            <div class="empty-title">{{$t('No asset selected')}}</div>
            <div class="empty-sub">{{$t('Select an asset to preview details here.')}}</div>
          </div>
        </div>
      </div>

      <!-- Resizer 2 -->
      <div 
        class="resizer" 
        :class="{ active: activeResizer === 2 }"
        @mousedown="startDrag(2, $event)"
        title="Drag to resize"
      ></div>
        <TagMetadataCommonComponent 
          v-if="selectedFileInfo"
          @playSubclip="playSubclip"
          :assetDetailsFromParent="getAssetDetails" :fileInfo="selectedFileInfo" screenType="Tag Metadata"
          :isMetadataDock="true"
          @updateAssetDeatils="updateAssetDeatils"
          @playTranscriptInMetadataView="playTranscriptInMetadataView" 
          @openSubclipWindowInMetadataView="openSubclipWindowInMetadataView" :isVideoFile="checkIfVideoFile" @navigateToAIComponent="traverseToAIComp"></TagMetadataCommonComponent>
    </section>  
    <v-menu
    v-model="showMoreSubMenu"
    :position-x="submenuX"
    :position-y="submenuY"
    absolute
    offset-y
    >
    <v-list :class="eOMenu?'vmenuOnHover':''">
      <v-list-item
        v-for="item in contextMenuMoreOptions"
        :key="item._id"
        @click="
          getEventHandler(
            item,
            'onClick',
            item.onEvents
          )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles), {boundComponent: getComponent})
        "
        >
        <v-list-item-title class="d-inline-flex">
          <div style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
      </v-list-item>
      <!-- <v-list-item
          v-if="Object.keys(selectedFileInfo).length != 0 && selectedFileInfo.asset_type != 'subclip' && selectedFileInfo.asset_state == 'READY' && selectedFileInfo.asset_type != 'catalog' && isEnabled('Hype-SocialMedia') && (selectedFileInfo.mime_type.startsWith('video') ||selectedFileInfo.mime_type.startsWith('image'))"
          @click="editAndShareAction()"
      >
        <v-list-item-title class="d-inline-flex">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hand-thumbs-up-fill" viewBox="0 0 16 16">
              <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a9.84 9.84 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733.058.119.103.242.138.363.077.27.113.567.113.856 0 .289-.036.586-.113.856-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.163 3.163 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.82 4.82 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>
            </svg>
          </div>
          <div style="padding-inline-start:7px;">Hype share</div>
        </v-list-item-title>
      </v-list-item> -->
    </v-list>
  </v-menu>
  <v-menu
    v-model="showMoreSubMenu"
    :position-x="submenuX"
    :position-y="submenuY"
    absolute
    offset-y
    >
    <v-list :class="eOMenu?'vmenuOnHover':''">
      <v-list-item
        v-for="item in contextMenuMoreOptions"
        :key="item._id"
        @click="
          getEventHandler(
            item,
            'onClick',
            item.onEvents
          )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles) , {boundComponent: getComponent})
        "
        >
        <v-list-item-title class="d-inline-flex">
          <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
      </v-list-item>

      <!-- ------removed hardcodede Hype Share option -->
      <!-- <v-list-item
          v-if="Object.keys(selectedFileInfo).length != 0 && selectedFileInfo.asset_type != 'subclip' && selectedFileInfo.asset_state == 'READY' && selectedFileInfo.asset_type != 'catalog' && isEnabled('Hype-SocialMedia') && (selectedFileInfo.mime_type.startsWith('video') ||selectedFileInfo.mime_type.startsWith('image'))"
          @click="editAndShareAction()"
      >
        <v-list-item-title class="d-inline-flex">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hand-thumbs-up-fill" viewBox="0 0 16 16">
              <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a9.84 9.84 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733.058.119.103.242.138.363.077.27.113.567.113.856 0 .289-.036.586-.113.856-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.163 3.163 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.82 4.82 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>
            </svg>
          </div>
          <div style="padding-inline-start:7px;">Hype share</div>
        </v-list-item-title>
      </v-list-item> -->
      
    </v-list>
  </v-menu>
    <v-menu 
    v-model="showArchiveToSubMenu"
    :position-x="submenuX"
    :position-y="submenuY"
    absolute
    offset-y
    >
    <v-list>
      <v-list-item
        v-for="item in contextMenuArchiveOptions"
        :key="item.pool_id"
        @click="archiveto(item.pool_id)"
        >
        <v-list-item-title class="d-inline-flex">
          <div v-html="getTargetBinIcon"></div>
          <div style="padding-inline-start:7px;">{{ getPoolLabel(item) }}</div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-menu 
    v-model="showOpenWithToolSubmenu"
    :position-x="submenuX"
    :position-y="submenuY"
    absolute
    offset-y
    >
    <v-list :class="eOMenu?'vmenuOnHover':''">
        <v-list-item
          v-for="item in contextMenuOpenWithOptions"
          :key="item._id"
          @click=" getEventHandler(
            item,
            'onClick',
            item.onEvents
          )($event, Object.assign({},selectedFileInfo) , {boundComponent: getComponent})"
          >
        <v-list-item-title v-if="'action_name' in item" class="d-inline-flex">
          <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
        </v-list-item>
      </v-list>
  </v-menu>
  <v-menu 
    v-model="showRetrieveFromSubmenu"
    :position-x="submenuX"
    :position-y="submenuY"
    absolute
    offset-y
    >
    <v-list>
      <v-list-item
        v-for="item in contextMenuRetrieveOptions"
        :key="item.pool_id"
        @click="retrieveFrom(item.pool_id)"
        >
        <v-list-item-title class="d-inline-flex">
          <div v-html="getTargetBinIcon"></div>
          <div style="padding-inline-start:7px;">{{ getPoolLabel(item) }}</div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-menu 
      v-model="showExportSubMenu"
      :position-x="submenuX"
      :position-y="submenuY"
      absolute
      offset-y
      >
      <v-list :class="eOMenu?'vmenuOnHover':''">
        <v-list-item
          v-for="item in contextMenuExportOptions"
          :key="item._id"
          @click="getExportEventHandler(item, $event)"
          >
        <v-list-item-title v-if="'action_name' in item" class="d-inline-flex">
          <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
          <v-list-item-title v-else class="d-inline-flex">
            <div v-html="getTargetBinIcon"></div>
            <div style="padding-inline-start:7px;">to {{ item.bin_id }}</div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
  </v-menu>
  <v-menu 
      v-model="showExportProxySubMenu"
      :position-x="submenuX"
      :position-y="submenuY"
      absolute
      offset-y
      >
      <v-list :class="eOMenu?'vmenuOnHover':''">
        <v-list-item
          v-for="(item,index) in contextMenuExportProxyOptions"
          :key="item._id+index"
          @click="getExportProxyEventHandler(item, $event)"
          >
        <v-list-item-title v-if="'action_name' in item" class="d-inline-flex">
          <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
          <v-list-item-title v-else class="d-inline-flex">
            <div v-html="getTargetBinIcon"></div>
            <div style="padding-inline-start:7px;">to {{ item.bin_id }}</div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
  </v-menu>
  <v-menu 
      v-model="showShareSubmenu"
      :position-x="submenuX"
      :position-y="submenuY"
      absolute
      offset-y
      >
      <v-list :class="eOMenu?'vmenuOnHover':''">
        <v-list-item
        v-for="item in contextMenuShareOptions"
        :key="item._id"
        @click="
          getEventHandler(
            item,
            'onClick',
            item.onEvents
          )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles) , {boundComponent: getComponent})
        "
        >
        <v-list-item-title class="d-inline-flex">
          <div v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
      </v-list-item>
      </v-list>
  </v-menu>
  <v-menu 
      v-model="showCatalogsIconSubmenu"
      :position-x="submenuX"
      :position-y="submenuY"
      absolute
      offset-y
      >
      <v-list :class="eOMenu?'vmenuOnHover':''">
        <v-list-item
        v-for="item in contextMenuCatalogIconOptions"
        :key="item._id"
        @click="
          getEventHandler(
            item,
            'onClick',
            item.onEvents
          )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles), {boundComponent: getComponent})
        "
        >
        <v-list-item-title class="d-inline-flex" :style="(item.label == 'From your Computer')?('position: relative;justify-content: flex-start;width: 100%;'):''">
          <div style="position: relative" v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
        <input type="file" v-if="item.label == 'From your Computer'" 
            id="img-input"
            ref="uploadFile"
            @change="uploadCPFromSystemUpload($event)"
            accept="image/*"
            style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%;">
      </v-list-item>
      </v-list>
  </v-menu>
  <v-menu 
      v-model="showAIToolsSubmenu"
      :position-x="submenuX"
      :position-y="submenuY"
      absolute
      offset-y
      >
      <v-list :class="eOMenu?'vmenuOnHover':''">
        <v-list-item
        v-for="item in contextMenuAIToolOptions"
        :key="item._id"
        @click="
          getEventHandler(
            item,
            'onClick',
            item.onEvents
          )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles) , {boundComponent: getComponent})
        "
        >
        <v-list-item-title class="d-inline-flex">
          <div v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
      </v-list-item>
      </v-list>
  </v-menu>
  <v-menu
    v-model="showNewSubMenu"
    :position-x="submenuNewX"
    :position-y="submenuNewY"
    absolute
    offset-y
    >
    <v-list :class="eOMenu?'vmenuOnHover':''">
      <v-list-item
        v-for="item in contextMenuNewOptions"
        :key="item._id"
        @click="
          getEventHandler(
            item,
            'onClick',
            item.onEvents
          )($event, Object.assign({},selectedFileInfo) , {boundComponent: getComponent})
        "
      >
        <v-list-item-title class="d-inline-flex">
          <div style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-menu
    v-model="showImportSubMenu"
    :position-x="submenuNewX"
    :position-y="submenuNewY"
    absolute
    offset-y
    >
    <v-list :class="eOMenu?'vmenuOnHover':''">
      <v-list-item
        v-for="item in contextMenuImportOptions"
        :key="item._id"
        @click="
          getEventHandler(
            item,
            'onClick',
            item.onEvents
          )($event, Object.assign({},selectedFileInfo) , {boundComponent: getComponent})
        "
      >
        <v-list-item-title class="d-inline-flex">
          <div style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-menu
    v-model="showMenu"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
    >
    <v-list :class="eOMenu?'vmenuOnHover':''">
      <v-list-item
      v-for="item in contextMenuOptions" :key="item._id" 
      @mouseenter="showSubmenu(item, $event)"
      @click='getEventHandler(item,"onClick",item.onEvents)($event,Object.assign({},selectedFiles), {boundComponent: getComponent})'
      >
        <v-list-item-title class="d-inline-flex"
          >
          <div style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
          <div style="padding-inline-start: 7px">
            {{$t(item.label)}}
          </div>
          <svg v-if="item.sub_menu != undefined && item.sub_menu != 'DEFAULT'" xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;fill: #c5c5c5;">
            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
          </svg>
          </v-list-item-title
        >
      </v-list-item>
      <v-list-item
          v-if="(workspace && workspace == 'Projects' && (Object.keys(selectedFileInfo).length != 0)) || (Object.keys(selectedFileInfo).length != 0 && selectedFileInfo.asset_type == 'subclip')" @mouseenter="preventSubMenuDisplay()"
          @click="openAssetInCatalog(selectedFileInfo)">
        <v-list-item-title class="d-inline-flex">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-folder-fill" viewBox="0 0 16 16">
                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
            </svg>
          </div>
          <div style="padding-inline-start:7px;">{{workspace && workspace == 'Projects'?$t('Open in catalogs workspace'):$t('Open Parent Asset')}}</div>
        </v-list-item-title>
      </v-list-item>
      <v-list-item
          v-if="Object.keys(selectedFileInfo).length != 0 && Object.keys(selectedFileInfo).includes('asset_type')" @mouseenter="preventSubMenuDisplay()"
          @click="openProperties()"
      >
        <v-list-item-title class="d-inline-flex">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
          </svg>
          </div>
          <div style="padding-inline-start:7px;">{{$t('Properties')}}</div>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  </div>
</template>

<script>
import catalogWorkspaceMixin from "../../mixins/CatalogWorkspaceMixin.js";
import TopNav from "../core/Topnavigation.vue";
import VideoPlayer from "../core/VideoPlayer.vue";
import customAudioPlayer from '../customAudioPlayer/AudioPlayerComponent.vue';
import Utils from "../../components.utils.js" ;
import {NotifierConstants} from "../../components.constants.js" ;
import {mapMutations, mapActions , mapGetters} from "vuex"
import Constants from "../../components.constants.js";
import TagMetadataCommonComponent from "../files/TagMetadataCommonComponent.vue";
import subclipPreviewMixin from '../../mixins/SubclipPreviewMixin.js';
import imagePreview from "../core/ImagePreviewDialog.vue";

export default {
  mixins:[catalogWorkspaceMixin,subclipPreviewMixin],
  name: 'MetadataView',
  props: ['contextMenuOptionsFromParent','pageFromParent','totalAssetsFromParent','assetsPerpageFromParent','selectedFileInfoFromParent','assets-from-parent','children-from-parent','autoPlay','transcriptPlayObject',"refreshFileInfoAndShowAsset", "catalogSelected","viewType","rootPathPermission","isAdvancedSearchEnabled", "getCookieValueOfJobPanel", "workspace", "rootCatalogInfo","isMetadataView","basicAssetInfo","isNLPSearchMode"],
  watch:{
      children: {
        deep: true,
        handler(val) {
          this.$emit('update-children-from-metadata', val);
        }
      },
      assetsList: {
        deep: true,
        handler(val) {
          this.$emit('update-assets-from-parent', val);
        }
      },
      totalAssets:{
        deep: true,
        handler(newVal){
          this.$emit('update-totalAssetsFromParent', newVal);
        }
      },
      assetsPerpage:{
        deep: true,
        handler(newVal){
          this.$emit('update-assetsPerpageFromParent', newVal);
        }
      },
      page: {
        deep: true,
        handler(newVal) {
          this.$emit('update-pageFromParent', newVal);
        }
      },
      basicAssetInfo: {
        deep: true,
        handler(newVal) {
          this.assetDetails = { ...newVal};
          this.isActive = newVal._id;
          const el = document.getElementById(this.isActive);
          if (el && el.classList && !el.classList.contains('active')) {
            el.classList.add('active');
          }
          this.$emit('update-basicAssetInfo', newVal);
        }
      },
      selectedFileInfoFromParent: {
        immediate: true,
        deep: true,
        handler(newVal) {
          console.log('PROP selectedFileInfoFromParent', JSON.stringify(newVal));
          if (newVal && Object.keys(newVal).length) {
            this.selectedFileInfo = { ...newVal };
            this.assetDetails = { ...newVal };
            this.isFileSelected(this.selectedFileInfo)
          }
        }
      },
      selectedFileInfo(newVal, oldVal) {
        if (!newVal) return;
        oldVal = oldVal || {};
        console.log('LOCAL selectedFileInfo changed to', JSON.stringify(newVal));
        this.assetDetails = newVal;
        if (newVal.category_id && !("path" in newVal)) {
          if (newVal.category_id !== oldVal.category_id) {
            this.updateRoute(newVal.category_id);
            this.isFileSelected(newVal);
          }
        } else {
          this.route = "";
        }

        if (newVal._id !== oldVal._id) {
          if (
            newVal.asset_type === 'subclip' &&
            (!newVal.subclip_type || ["soft", "smart", "image_captioned"].includes(newVal.subclip_type))
          ) {
            this.initializeSubclipPreview(newVal);
            return;
          } else {
            try {
              this.removeTimeLineMarkers();
            } catch (e) {
              console.log(e);
            }
          }

          try {
            if (this.videoFrameCallbackID && this.controller && this.controller.player) {
              console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
              this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
            }
          } catch (e) {
            console.log(e);
          }
        }

        if (newVal.mime_type && newVal.mime_type.startsWith("video")) {
          if (this.getLowresPath(newVal) !== this.getLowresPath(oldVal)) {
            this.videoOptions.sources = [{
              src: this.getLowresPath(newVal),
              type: "video/mp4"
            }];

            this.isPlayerCanBeLoaded = true;

            this.$nextTick(() => {
              if (this.controller && this.controller.player) {
                this.controller.player.src(this.videoOptions.sources);
                this.controller.player.load();
              }
            });
          }
        } else if (newVal.mime_type && newVal.mime_type.startsWith("audio")) {
          if (this.getAudiowaveform(newVal) != this.getAudiowaveform(oldVal)){
            this.audioUrl = this.getAudiowaveform(newVal)
          }
        }
      },

     subclipDetails(newVal, oldVal){
          if(newVal && Object.keys(newVal).length){
              if(newVal._id != oldVal._id){
                  if(this.subclipDetails && Object.keys(this.subclipDetails).length && this.subclipDetails.asset_type && this.subclipDetails.asset_type == 'subclip' && (!this.subclipDetails.subclip_type || ["soft","smart","image_captioned"].includes(this.subclipDetails.subclip_type))){
                      if(this.isAudioFile){
                          this.$refs.audioPlayerRef.playSubclipArea(newVal);
                          return;
                      }
                      this.addSubclipMarkers(newVal);
                  }
              }
          }
      },

      transcriptPlayObject(newVal, oldVal){
          console.log(`[transcriptPlayObject transcriptPlayObject]`,newVal, oldVal);
         if(newVal && Object.keys(newVal).length){
          if(this.isVideoFile && this.autoPlay){
                  try{
                      this.removeTimeLineMarkers();
                  }catch(e){console.log(e)}
                  this.controller.player.currentTime(newVal.media_in/1000);
                  this.controller.player.play();
              }else if(this.isAudioFile){
                  // this.$refs.audioPlayerRefEl.currentTime = (newVal.media_in/1000);
                  // this.$refs.audioPlayerRefEl.play();
                  this.$refs.audioPlayerRef.setCurrentTime(newVal.media_in/1000);
                  this.$refs.audioPlayerRef.playVideo();
              }
         }
      }
  },
  data() {
    return {
      showFullFileName: false,
      showOtherFilesPreviewDialog:false,
      controller:{},
      route:"",
      audioLoaded: false,
      isPlaying: false,
      audioUrl:null,
      videoOptions: {
        autoplay: false,
        controls: true,
        nativeTextTracks: true,
        controlBar:{
                'pictureInPictureToggle': false,
                'progressControl': true,
                'remainingTimeDisplay': false,

            volumePanel: {
                inline: false,
                vertical: true
            },

            playToggle: false
        },
        preload: "metadata",
        sources: []
      },
      svgIconForStorageClass:{"Amazon S3 Glacier":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                              "Amazon S3 Glacier Instant Retrieval":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                              "Amazon S3 Standard":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                              "Disk":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>' },
      isPlayerCanBeLoaded:false,
      currentVideoSpeed : 1,    
      frameRate: 25,    
      searchQuery: '',
      language: 'English',
      focusMode: false,
      activeFileId: 1,
      activeTab: 'subclips',
      activeResizer: null,
      cols: [25,30,45],
      minPct: [20, 29, 42],
      maxPct: [30, 45, 70],
      assetDetails:{},
      catalogs: [],
      files:[],
      tabs: [],
      metadata: {},
      transcriptLines: [],
      subclips: [],
      ocrData: [],
      faces: [],
      subclipDetails:null
    };
  },

  components: {
    "top-nav": TopNav,
    customAudioPlayer,
    "video-player": VideoPlayer,
    TagMetadataCommonComponent,
    "ImagePreviewDialog":imagePreview
  },
  
  computed: {
    getAssetDetails(){
      if(this.selectedFiles && Object.keys(this.selectedFiles).length){
        return {};
      }else if(this.basicAssetInfo && Object.keys(this.basicAssetInfo).length){
        return this.basicAssetInfo;
      }else if(this.assetDetails && Object.keys(this.assetDetails).length){
        return this.assetDetails;
      }
    return {};
    },
    effectiveTotalAssets() {
      if (this.totalAssets && this.totalAssets >= 0) {
        return this.totalAssets;
      }
      if (this.totalAssetsFromParent && this.totalAssetsFromParent >= 0) {
        return this.totalAssetsFromParent;
      }
      return -1; // or any default value you prefer
    },

    effectiveAssetsPerPage() {
      if (this.assetsPerpage && this.assetsPerpage > 0) {
        return this.assetsPerpage;
      }
      if (this.assetsPerpageFromParent && this.assetsPerpageFromParent > 0) {
        return this.assetsPerpageFromParent;
      }
      return -1; // or any default value you prefer
    },
    effectiveAssets() {
      if (Array.isArray(this.assetsList) && this.assetsList.length > 0) {
        return this.assetsList;
      }
      if (Array.isArray(this.assetsFromParent) && this.assetsFromParent.length > 0) {
        return this.assetsFromParent;
      }
      return [];
    },

    effectiveChildren() {
      if (this.children && this.children.length > 0) {
        return this.children;
      }
      if (Array.isArray(this.childrenFromParent) && this.childrenFromParent.length > 0) {
        return this.childrenFromParent;
      }
      return [];
    },
      checkIfVideoFile(){
        if(this.assetDetails && this.assetDetails.mime_type){
          if(this.assetDetails.mime_type.split("/")[0] == 'video'){
            return true
          }
        }
        return false
      },
      barcodeInfoFromStartup:{
          get(){
              return this.$store.state.startUpData.startUpDataDetails;
          }
      },
      isAudioFile(){
          try {
            if(this.getAssetDetails){
              return this.getAssetDetails.mime_type.startsWith("audio")   
            }
          } catch (err) {
              console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
          }
          return false
      },
      isVideoFile(){
          try {
              if(this.getAssetDetails && this.getAssetDetails.asset_type && this.getAssetDetails.asset_type == 'subclip' && (!this.getAssetDetails.subclip_type || ["soft","smart","image_captioned"].includes(this.getAssetDetails.subclip_type))) {
                  return true;
              }   
          } catch (err) {
              console.error(`[isVideoFile][files][Error while checking filetype-${err}]`)
          }
          try {
            if(this.getAssetDetails){
              return this.getAssetDetails.mime_type.startsWith("video")   
            }
          } catch (err) {
              console.error(`[isVideoFile][files][Error while checking filetype-${err}]`)
          }
          return false
      },
      isImageFile(){
          try {
            if(this.getAssetDetails){
              return this.getAssetDetails.mime_type.startsWith("image") || this.getAssetDetails.mime_type.startsWith("doc")
            }
          } catch (err) {
              console.error(`[isImageFile][files][Error while checking filetype-${err}]`)
          }
          return false
      },
      isFullscreenPreviewAllowed(){
          let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
          return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.selectedFileInfo)) > -1
      },
    selectedFile() {
      return this.files.find(f => f.id === this.activeFileId) || this.files[0];
    },
    
    splitStyles() {
      if (this.focusMode) {
        return {
          gridTemplateColumns: '6% 6px 22% 6px 72%'
        };
      }
      
      const total = this.cols.reduce((a, b) => a + b, 0);
      const normalized = this.cols.map(c => c * (100 / total));
      return {
        gridTemplateColumns: `${normalized[0]}% 6px ${normalized[1]}% 6px ${normalized[2]}%`
      };
    },
    ...mapGetters("registry",["getDontPlayOverlayScreenOverMiniplayerAssetDoc"]),
  },
  methods: {
    ...mapActions("assets",["getCategoryTreefromId","getAssetInfoFromServer"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapMutations("assets",["activeAssetDetailsPlayer"]),
    handleMetadataViewKeyboardShortcuts(event){
            let keyCode = event.keyCode || event.which;
            let pressedElement = String(event.target.nodeName).toLowerCase();
            if(pressedElement == 'input' || pressedElement == 'textarea' || pressedElement == 'select' ) return true;
            let videoAudioRef = null;
            if(this.isVideoFile){
                videoAudioRef = this.$refs.videoPlayerEl.$el.querySelector('video');
            }

            if(this.isAudioFile){
                videoAudioRef = this.$refs.audioPlayerRef.$el.querySelector('audio');
            }
             
            if(keyCode === 32){ //spacebar
               event.preventDefault(); // don't allow to scroll
               try{
                    if(this.$route && this.getDontPlayOverlayScreenOverMiniplayerAssetDoc.includes(this.$route.name)){
                         return; // don't play when tag-metadata window is opened on top , it will avoid 2 times playing
                    }
                }catch(e){console.log(e)}

                if(videoAudioRef && videoAudioRef.paused){
                    this.isPlaying = true;
                    videoAudioRef.play()
                }else{
                    this.isPlaying = false;
                    videoAudioRef.pause();
                }
            }

    },
    handleMetadataViewColumnsUpdated(columns) {
      this.handleColumnsUpdated(columns);
      this.$emit('columns-updated', columns);
    },
    async copyFileName(fileName) {
      try {
        await navigator.clipboard.writeText(fileName);
        this.$toast?.success?.(this.$t('File name copied'));
      } catch (e) {
        const textArea = document.createElement('textarea');
        textArea.value = fileName;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.$toast?.success?.(this.$t('File name copied'));
      }
    },
    showAssetPreview(){
      if(this.selectedFileInfo.mime_type && this.selectedFileInfo.mime_type.startsWith("image")){
        this.showOtherFilesPreviewDialog = true;
      }
    },
    playSubclip(subclipInfo){
      this.subclipDetails = subclipInfo;
      if(this.subclipDetails && Object.keys(this.subclipDetails).length && this.subclipDetails.asset_type && this.subclipDetails.asset_type == 'subclip' && (!this.subclipDetails.subclip_type || ["soft","smart","image_captioned"].includes(this.subclipDetails.subclip_type))){
          if(this.isAudioFile){
              this.$refs.audioPlayerRef.playSubclipArea(this.subclipDetails);
              return;
          }
          this.addSubclipMarkers(this.subclipDetails);
      }
    },
    openSubclipWindowInMetadataView(selectedSubclip,subComponentName,compType){
      this.isPlaying = false;
      let paramObj = {assetId: this.assetDetails._id, fileInfo:Object.assign({}, this.assetDetails),parentinfo:this.$route}
        if(selectedSubclip){
          paramObj["subclipId"] = selectedSubclip.asset_id;
          paramObj["subclipInfo"] = selectedSubclip;
        }
      let route_name = "metadata-dock-bin-sub-clips-manager";
      if(this.$route.name == 'catalogs-display' && compType == 'subclips'){
        route_name = "metadata-dock-sub-clips-manager";
      }
      if(compType == 'media-edit'){
        if(this.$route.name == 'catalogs-display'){
          route_name = "PartialRetrieve-from-metadata-dock";
        }else{
          route_name = "PartialRetrieve";
        }
      }
      if(compType == "transcript"){
        if(this.$route.name == 'catalogs-display'){
          route_name = "metadata-dock-video-transcript-manager"
        }else{
          route_name = "bins-metadata-dock-video-transcript-manager"
        }
      }
      this.$router.push({
          name:route_name,
          params:paramObj
        })
    },
    playTranscriptInMetadataView(transcript){
      if(this.isVideoFile){
        setTimeout(()=> {
            this.addSubclipMarkers(transcript);
          },100);
        this.controller.player.currentTime(transcript.media_in/1000);
        this.controller.player.play();
      }else if(this.isAudioFile){
          this.$refs.audioPlayerRefEl.currentTime = (transcript.media_in/1000);
          this.$refs.audioPlayerRefEl.play();
      }
    },
    getColorBasedOnExpiry(locationInfo,storage){
          return Utils.getAWSStorageIconColorBasedOnExpiry(locationInfo,storage)
      },
      getMasterAssetForSubclip(fileObj){
          return new Promise((resolve) => {
              this.getAssetInfoFromServer({params:{assetId:fileObj.master_asset_id}}).then((data) => {
                  if(data && data.asset)
                     resolve(data.asset);
              })
          });
      },
     getDurationFormat(duration){
      const date = new Date(duration * 1000); // convert to milliseconds
      const hours = date.getUTCHours();
      if(hours > 0){
          return '00:00:00.00'
      }else{
          return '00:00.00'
      }
     },
      formatDurationHHMMSS_or_MMSS(duration) {
         return Utils.getExactDuationInSeconds(duration , this.frameRate, '.');
      },
      setProgressLabel(duration){
          try{
              [].forEach.call(document.querySelectorAll(`.player-current-time-division`),(el) => {
                  el.remove();
              });
          }catch(e){console.log(e)}
          let progressBar = this.$refs.videoPlayerEl.$el.querySelector('.vjs-control-bar');
          let currentProgressEl = document.createElement('div');
          currentProgressEl.classList.add('player-current-time-division');
          currentProgressEl.innerHTML = `<span class="currrent-time">${this.getDurationFormat(duration)}</span> <span class="time-division-label">/</span> <span class="full-time-of-time-division">${this.formatDurationHHMMSS_or_MMSS(duration)}</span>`;
          progressBar.insertBefore(currentProgressEl,progressBar.querySelector('.vjs-fullscreen-control.vjs-control'));
      },
      playerFullyLoaded(ref,type){
          if(this.selectedFileInfo && this.selectedFileInfo.asset_type && this.selectedFileInfo.asset_type == 'subclip' && (!this.selectedFileInfo.subclip_type || ["soft","smart","image_captioned"].includes(this.selectedFileInfo.subclip_type)))
              this.addSubclipMarkers(this.selectedFileInfo);

          if(this.subclipDetails && Object.keys(this.subclipDetails).length && this.subclipDetails.asset_type && this.subclipDetails.asset_type == 'subclip' && (!this.subclipDetails.subclip_type || ["soft","smart","image_captioned"].includes(this.subclipDetails.subclip_type))){
              this.addSubclipMarkers(this.subclipDetails);
          }
          let media = null;
          if(type == 'video'){
            media = this.$refs[ref].$el.querySelector(type);
            try{
               this.setProgressLabel(this.controller.player.duration());
            }catch(e){console.log(e)}
              try{
                  this.activeAssetDetailsPlayer({type:'video',player:this.controller.player})
              }catch(e){console.log('e')}
          }else{
            media = this.$refs[ref];
             try{
                  this.activeAssetDetailsPlayer({type:'audio',player:media})
             }catch(e){console.log('e')}
          }
          media.playbackRate = this.currentVideoSpeed;

          if(media.paused){
              this.isPlaying = false;
          }
         
          try{
              media.removeWSEventListener("pause", this.updatePlayerPauseAction);
              media.removeWSEventListener("play",  this.updatePlayerPlayAction);
          }catch(e){console.log(e)}
          media.addEventListener("pause", this.updatePlayerPauseAction);
          media.addEventListener("play",  this.updatePlayerPlayAction);

          if(this.transcriptPlayObject && Object.keys(this.transcriptPlayObject).length){
                if(this.isVideoFile){
                  this.controller.player.currentTime(this.transcriptPlayObject.media_in/1000);
                  this.controller.player.play();
                }else if(this.isAudioFile){
                    this.$refs.audioPlayerRefEl.currentTime = (this.transcriptPlayObject.media_in/1000);
                    this.$refs.audioPlayerRefEl.play();
                }
          }
      },
      handleFullScreenRequest(){
         if(document.querySelectorAll('.subclip-timeline-marker') && document.querySelectorAll('.subclip-timeline-marker').length){
              if(this.controller.player.isFullscreen()){
                  setTimeout(() => {
                      this.addLineBetweenMarkers();
                  },100);
              }else{
                  this.addLineBetweenMarkers();
              }
          }
      },
      async initializeSubclipPreview(fileObj){
         let asset = await this.getMasterAssetForSubclip(fileObj);
         this.videoOptions.sources = [{
              src:this.getLowresPath(asset),
              type: "video/mp4"
          }]
          // if (this.controller.player && !this.controller.player.paused()){
          //     this.controller.restartPlayer(this.videoOptions.sources[0])
          // }
          this.controller.player.src(this.videoOptions.sources);
          this.controller.player.load();
      },
      addSubclipMarkers(markinMarkoutObj){
       /*    if(this.subclipDetails && Object.keys(this.subclipDetails).length){ // change to subclip from metadata dock
              markinMarkoutObj = this.subclipDetails;
          } */
          this.$refs.videoPlayerEl.$el.classList.add('sub-clip-markin-markout-play');
          let start = this.getMarkerValue(markinMarkoutObj.markers.start);
          let end = this.getMarkerValue(markinMarkoutObj.markers.end);
          this.addMarkersToTimeline([{time:start,name:'markin'},{time:end,name:'markout'}]);
          setTimeout(()=> {
              this.addLineBetweenMarkers();
          },100);
          this.controller.player.currentTime(start);
          if(this.controller.player.paused()  && this.autoPlay) this.controller.player.play();
          try{
              if(this.videoFrameCallbackID) {
                  console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                  this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
              }
          }catch(e){console.log(e)}
          this.$nextTick(()=>{
              this.currentMarkoutValue = end;
              // alert('inside');
              this.videoFrameCallbackID = this.controller.player.requestAnimationFrame(this.videoFrameCallback);
          });
          // this.controller.player.pause();
      },
      playSubClipPreview(markinMarkoutObj,callback){
          this.controller.player.currentTime(markinMarkoutObj.markin);
          this.controller.player.play();
          try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
          this.controller.player.on('timeupdate',() =>{ 
              if(this.controller.player.currentTime() >= markinMarkoutObj.markout){
                  this.controller.player.pause();
                 if(callback && typeof callback == 'function') callback('stopPlayer');
                 try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
              }
          });
      },
      getSvgIconForStorageClass(type){
          return this.svgIconForStorageClass[type];
      },
      getFileNameForDetails(fileInfo){
          return fileInfo.file_name?fileInfo.file_name:fileInfo.slug_name
      },
      getFilePath(fileInfo){
          if ("path" in fileInfo){
              return fileInfo.path
          }else{
              return this.getCategoryRoutefromId(fileInfo.category_id)
          }
          
      },
      getCategoryRoutefromId(){
          return this.route
      },
      setController(controller){
          this.controller = controller;
          try{
             this.controller.player.off("fullscreenchange", this.handleFullScreenRequest);
          }catch(e){console.log(e)}
          this.controller.player.on("fullscreenchange", this.handleFullScreenRequest);
      },
      
      closeAssetDetails(thumbnail){
          this.$emit("hideAssetDetails",thumbnail);
      },
      humaniseSize(file){
          if(file.size){
              let data = Utils.humanizeSize(file.size);
              return `${data["value"]} ${data["unit"]}`;
          }else{
              return '-'
          }
      },
      getLowresPath(file){
        return Utils.getLowresPathfromFileInfo(file)
      },
      getAudiowaveform(file){
          return Utils.getAudiowaveformFromFileInfo(file)
      },
      updateRoute(categoryId){
        if(categoryId.trim().length <= 0){
          return
        }
        this.getCategoryTreefromId({ params: { categoryId:categoryId}}).then((route)=>{
          this.route = route
      })
      },
      handleFileUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
          let path = notification.message.path
          let parent_path = notification.message.parent_path
          if (this.selectedFileInfo.path == path){
              if (this.selectedFileInfo.mime_type.startsWith("video")){
                  Object.assign(this.selectedFileInfo, notification.message)

                  this.videoOptions.sources = [{
                          src:this.getLowresPath(notification.message),
                          type: "video/mp4"
                      }]
                  if (  this.controller.player){
                      this.controller.restartPlayer(this.videoOptions.sources[0])
                  }
              }else if (this.selectedFileInfo.mime_type.startsWith("audio")){
                  this.audioUrl = this.getAudiowaveform(this.selectedFileInfo)
              }else if (this.selectedFileInfo.mime_type.startsWith("image")){
                  Object.assign(this.selectedFileInfo, notification.message)
              }
              console.log(`[handleFileUpdateNotification][AssetDetails][File(${path}) updated in path->${parent_path}]`)
          }
          }
      },
      handleFileArchivedNotification(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          if(notification.message){
          let path = notification.message.path
          if (this.selectedFileInfo.path == path && this.selectedFileInfo.storage_class != undefined){
              this.selectedFileInfo.storage_class = notification.message.storage_class;
          }
          }
      },
      registerForNotification(){
          this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification, 
                                   callback:this.handleFileUpdateNotification,
                                   parent:"AssetDetails"})
          this.addWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleFileArchivedNotification,parent:"AssetDetails"})
      },
      unRegisterForNotification(){
          this.removeWSEventListener({eventname:NotifierConstants.fileModifiedNotification, 
                                   callback:this.handleFileUpdateNotification,
                                   parent:"AssetDetails"})
          this.removeWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleFileArchivedNotification,parent:"AssetDetails"})
      },
       
      updateFastwardValue(speedAction){
          let video = null;
          if(this.isVideoFile){
             video = this.$refs.videoPlayerEl.$el.querySelector('video');
          }else{
             video = this.$refs.audioPlayerRef.getAudioPlayer()//this.$refs.audioPlayerRefEl;
          }
  
          if(speedAction == 'forward'){
              if(this.currentVideoSpeed == 0.5){
                  this.currentVideoSpeed = 1;
              }else if(this.currentVideoSpeed > 0.5 && this.currentVideoSpeed < 5){
                  this.currentVideoSpeed++
              }else if(this.currentVideoSpeed >= 5){
                  this.currentVideoSpeed = 0.5;
              }
          }
          video.playbackRate = Number(this.currentVideoSpeed);
      
      },
      resetVideoSpped(){
         let video = null;
          if(this.isVideoFile){
             video = this.$refs.videoPlayerEl.$el.querySelector('video');
          }else{
             video = this.$refs.audioPlayerRef.getAudioPlayer();//this.$refs.audioPlayerRefEl;
          }
          video.playbackRate = 1;
          this.currentVideoSpeed = 1;
      },
      forwardBackwardVideoByFrame(type){
          if (!type) {
              console.log("Invalid type");
              return false;
          }
          let video = null;
          if(this.isVideoFile){
             video = this.$refs.videoPlayerEl.$el.querySelector('video');
          }else{
             video = this.$refs.audioPlayerRef.getAudioPlayer();//this.$refs.audioPlayerRefEl;
          }
          if (video) {
              let dur = video.duration; //full duration of video
              let curDur = video.currentTime; //current time of a video
              if (dur != undefined && curDur != undefined) {
                  //forward 1 second
                  if (type == "forward" && curDur < (dur + 0.04)) {
                      video.currentTime = (curDur + 0.04)
                      Utils.getExactDuationInSeconds(curDur + 0.04);
                  }

                  //backward 1 second
                  if (type == "backward" && curDur > 0.04) {
                      video.currentTime =(curDur - 0.04)
                      Utils.getExactDuationInSeconds(curDur - 0.04);
                  }
              }
          }
      },

      forwardBackwardVideoBy1Sec(action) {
          if (!action) {
              console.log("Invalid action");
              return false;
          }
          let video = null;
          if(this.isVideoFile){
             video = this.$refs.videoPlayerEl.$el.querySelector('video');
          }else{
             video = this.$refs.audioPlayerRef.getAudioPlayer();//this.$refs.audioPlayerRefEl;
          }
          if (video) {
              let dur = video.duration; //full duration of video
              let curDur = video.currentTime; //current time of a video
              if (dur != undefined && curDur != undefined) {
                  //forward 1 second
                  if (action == "forward" && curDur < (dur + 1)) {
                      video.currentTime = curDur + 1
                  }
      
                  //backward 1 second
                  if (action == "backward" && curDur > 1) {
                  video.currentTime = curDur - 1
                  }
              }
          }
      
      },

      playPauseToggle(){
          if(this.isAudioFile){
              if(this.$refs.audioPlayerRef.getAudioPlayer().paused){
                  this.$refs.audioPlayerRef.getAudioPlayer().play();
                  this.isPlaying = true;
              }else{
                  this.$refs.audioPlayerRef.getAudioPlayer().pause();
                  this.isPlaying = false;
              }
              return;
          }
          let video = null;
          if(this.isVideoFile){
             video = this.$refs.videoPlayerEl.$el.querySelector('video');
          }else{
             video = this.$refs.audioPlayerRefEl;
          }
          if(video.paused){
              video.play();
              this.isPlaying = true;
          }else{
              video.pause();
              this.isPlaying = false;
          }

          try{
              window.blur();
          }catch(e){console.log(e)}
      },

      updatePlayerPauseAction(){
          this.isPlaying = false;
          try{
              if(this.videoFrameCallbackID) {
                  console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                  this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
              }
          }catch(e){console.log(e)}
      },

      updatePlayerPlayAction(){
          this.isPlaying = true;
      },
    selectFile(file) {
      this.activeFileId = file.id;
    },
    
    activateTab(tabId) {
      this.activeTab = tabId;
    },
    
    toggleFocus() {
      this.focusMode = !this.focusMode;
      if (this.focusMode) {
        this.cols = [6, 22, 72];
      } else {
        this.cols = [16, 34, 50];
      }
    },
    
    startDrag(resizerIndex, event) {
      this.activeResizer = resizerIndex;
      const startX = event.clientX;
      const startCols = [...this.cols];
      const rect = this.$refs.split.getBoundingClientRect();
      const w = rect.width;
      
      const onMove = (ev) => {
        const dx = ev.clientX - startX;
        const dPct = (dx / w) * 100;
        
        if (resizerIndex === 1) {
          let c0 = startCols[0] + dPct;
          let c1 = startCols[1] - dPct;
          
          c0 = this.clamp(c0, this.minPct[0], this.maxPct[0]);
          c1 = this.clamp(c1, this.minPct[1], this.maxPct[1]);
          
          const sum = startCols[0] + startCols[1];
          const adj = sum - (c0 + c1);
          c1 = this.clamp(c1 + adj, this.minPct[1], this.maxPct[1]);
          
          this.cols = [c0, c1, startCols[2]];
        } else {
          let c1 = startCols[1] + dPct;
          let c2 = startCols[2] - dPct;
          
          c1 = this.clamp(c1, this.minPct[1], this.maxPct[1]);
          c2 = this.clamp(c2, this.minPct[2], this.maxPct[2]);
          
          const sum = startCols[1] + startCols[2];
          const adj = sum - (c1 + c2);
          c2 = this.clamp(c2 + adj, this.minPct[2], this.maxPct[2]);
          
          this.cols = [startCols[0], c1, c2];
        }
        
        // Normalize
        const total = this.cols[0] + this.cols[1] + this.cols[2];
        this.cols = this.cols.map(c => c * (100 / total));
      };
      
      const onUp = () => {
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('mouseup', onUp);
        this.activeResizer = null;
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
      };
      
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
    },
    
    clamp(v, min, max) {
      return Math.max(min, Math.min(max, v));
    },

    updateAssetDeatils(assetDetailsVal) {
      if (!assetDetailsVal || !Object.keys(assetDetailsVal).length) {
        return;
      }

      if (this.selectedFiles && Object.keys(this.selectedFiles).length) {
        this.assetDetails = {};
      }else{  
        Object.assign(this.assetDetails, assetDetailsVal)
      }
    }
  },
  created(){
      window.addEventListener('keydown', this.handleMetadataViewKeyboardShortcuts);
      if(this.pageFromParent){
          this.page = this.pageFromParent;
      }
      else if (this.$route.query.page && !isNaN(parseInt(this.$route.query.page)) && parseInt(this.$route.query.page) > 0) {
        this.page = this.$route.query.page;
      }

      if(this.basicAssetInfo && Object.keys(this.basicAssetInfo).length){
          this.assetDetails = this.basicAssetInfo;
          this.isActive = this.assetDetails._id;
          const el = document.getElementById(this.isActive);
          if (el && el.classList && !el.classList.contains('active')) {
            el.classList.add('active');
          }
      }
      if(this.selectedFileInfoFromParent && Object.keys(this.selectedFileInfoFromParent).length){
          this.selectElement(null,this.selectedFileInfoFromParent,true,true);
          this.isFileSelected(this.selectedFileInfoFromParent)
      }
      if(this.assetDetails && this.fileInfo && !('file_id' in this.assetDetails)){
        this.$set(this.assetDetails, 'file_id', this.fileInfo.file_id || null);
      }
      if ((this.assetDetails.category_id)&&(!("path" in this.assetDetails))){
          this.updateRoute(this.assetDetails.category_id)
      }

      this.frameRate = this.assetDetails.frame_rate;

      this.registerForNotification()

      if(this.assetDetails && this.assetDetails.asset_type && this.assetDetails.asset_type == 'subclip'  && (!this.assetDetails.subclip_type || ["soft","smart","image_captioned"].includes(this.assetDetails.subclip_type))){
              this.getMasterAssetForSubclip(this.assetDetails).then((data) => {
                  this.videoOptions.sources = [{
                      src:this.getLowresPath(data),
                      type: "video/mp4"
                  }];
                  this.isPlayerCanBeLoaded = true;
              });
              return;
      }

      this.isPlayerCanBeLoaded = true;

      if (this.assetDetails && this.assetDetails.mime_type && this.assetDetails.mime_type.startsWith("video")){
          this.videoOptions.sources = [{
              src:this.getLowresPath(this.assetDetails),
              type: "video/mp4"
    }]
      }else if (this.assetDetails && this.assetDetails.mime_type && this.assetDetails.mime_type.startsWith("audio")){
          this.audioUrl = this.getAudiowaveform(this.assetDetails)
      }
  },
  beforeDestroy(){
      window.removeEventListener('keydown', this.handleMetadataViewKeyboardShortcuts);
      this.unRegisterForNotification();
        try{
          if(this.videoFrameCallbackID) {
              console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
              this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
          }
      }catch(e){console.log(e)}
      this.showMenu = false;
      this.eventsAttached = false;
  }
};
</script>

<style>
/* Global CSS variables - must be unscoped for proper inheritance */
:root {
  --bg: #0b0f14;
  --panel: #0f1620;
  --text: #d7dde7;
  --muted: #8b96a8;
  --line: rgba(255, 255, 255, 0.08);
  --line2: rgba(255, 255, 255, 0.12);
  --hover: rgba(255, 255, 255, 0.05);
  --accent: #2dd4ff;
  --accent2: #3b82f6;
  --good: #22c55e;
  --warn: #f59e0b;
  --bad: #ef4444;
  --radius: 14px;
  --shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
  --font: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
}
</style>

<style scoped lang="scss">
.fusion-metadata-view-root{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    font-family: var(--font);
    color: var(--text);
    background: radial-gradient(1200px 700px at 40% -10%, rgba(45,212,255,.12), transparent 60%),
                radial-gradient(900px 600px at 90% 10%, rgba(59,130,246,.10), transparent 55%),
                var(--bg);
  .catalogs-workspace-sections{
    padding: 10px 0px;
    padding-top: 0px;
  }
  * {
    box-sizing: border-box;
  }

  .active{
    border-color: rgba(45, 212, 255, 0.22) !important;
      background: rgba(45, 212, 255, 0.06) !important;
      border: 1px solid var(--line) !important;
    .card{
      border-color: rgba(45, 212, 255, 0.22) !important;
      background: rgba(45, 212, 255, 0.06) !important;
      border: 1px solid var(--line) !important;
    }
  }
  
  .split {
    height: 100%;
    display: grid;
    gap: 2px;
    position: relative;
    min-width: 900px;
    padding: 10px;
    text-align: justify;
    width:98.7%;
  }
  
  .panel {
    border: 1px solid var(--line);
    border-radius: var(--radius);
    background: rgba(15, 22, 32, 0.75);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.24);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-width: 260px;
  }
  
  .panelHeader {
    padding: 12px 12px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border-bottom: 1px solid var(--line);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0));
  }
  
  .panelHeader .title {
    font-weight: 700;
    letter-spacing: 0.2px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .panelHeader .subtitle {
    color: var(--muted);
    font-size: 12px;
    margin-top: 2px;
    width: 100%
  }
  
  .panelHeader .right {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--muted);
    font-size: 12px;
  }
  
  .panelBody {
    padding: 12px;
    overflow: auto;
    flex: 1;
  }
  
  /* Resizers */
  .resizer {
    width: 6px;
    cursor: col-resize;
    border-radius: 8px;
    position: relative;
    z-index: 5;
    background: transparent;
  }
  
  .resizer::before {
    content: "";
    position: absolute;
    top: 12px;
    bottom: 12px;
    inset-inline-start: 50%;
    width: 1px;
    transform: translateX(-50%);
    background: rgba(255, 255, 255, 0.06);
    border-radius: 999px;
  }
  
  .resizer:hover::before {
    background: rgba(45, 212, 255, 0.35);
  }
  
  .resizer.active::before {
    background: rgba(45, 212, 255, 0.55);
  }
  
  /* Catalog */
  .crumb {
    color: var(--muted);
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .grid2 {
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 10px;
    margin-top: 10px;
  }
  
  .cardMini {
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.02);
    border-radius: 12px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;    
    width:inherit;
  }
  
  .cardMini:hover {
    background: var(--hover);
  }
  
  .cardMini .k {
    font-size: 12px;
    color: var(--muted);
  }
  
  .cardMini .card-catalog-or-asset {
    font-size: 13px;
    font-weight: 650;
    display:flex;
    gap:6px;
    width:100%;
    position:relative;
    .catalog-name{
      white-space: nowrap;
      width: 79%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  
  .files {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .fileRow {
    display: flex;
    gap: 10px;
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.02);
    border-radius: 12px;
    padding: 10px;
    cursor: pointer;
    align-items: flex-start;
    margin-bottom:10px;
  }
  
  .fileRow:hover {
    background: var(--hover);
    .shortcut-actions-type-icons-wrapper{
      visibility: visible;
    }
  }
  
  .fileRow.active {
    border-color: rgba(45, 212, 255, 0.22);
    background: rgba(45, 212, 255, 0.06);
  }
  
  .thumb {
    width: 54px;
    height: 40px;
    border-radius: 10px;
    border: 1px solid var(--line);
    background: linear-gradient(135deg, rgba(45, 212, 255, 0.16), rgba(255, 255, 255, 0.03));
    position: relative;
    overflow: hidden;
    flex: 0 0 auto;
    display:flex;
    align-items:center;
    justify-content:center;
    .metadata-view-thumbnail{
      width:100px;
      height:100px;
      opacity:1;
      position:relative;
      img{
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
    }
  }
  
  .resolution-badge {
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.25);
    color: rgba(255, 255, 255, 0.85);
  }
  
  .fileMeta {
    min-width: 0;
  }
  
  .fileMeta .name {
    font-weight: 650;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .fileMeta .small {
    font-size: 12px;
    color: var(--muted);
    margin-top: 2px;
    display: flex;
    gap: 8px;
    align-items: center;
  }
  
  .dotGood, .dotWarn, .dotBad {
    width: 8px;
    height: 8px;
    border-radius: 999px;
  }
  
  .dotGood {
    background: var(--good);
  }
  
  .dotWarn {
    background: var(--warn);
  }
  
  .dotBad {
    background: var(--bad);
  }
  
  /* Player */
  .playerWrap {
    border: 1px solid var(--line);
    background: rgba(0, 0, 0, 0.35);
    border-radius: 14px;
    overflow: hidden;
  }
  
  .player {
    aspect-ratio: 16/9;
    width: 100%;
    background: radial-gradient(900px 400px at 40% 20%, rgba(45, 212, 255, 0.18), transparent 60%),
                radial-gradient(700px 350px at 70% 30%, rgba(59, 130, 246, 0.16), transparent 55%),
                linear-gradient(180deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02));
    position: relative;
    display: grid;
    place-items: center;
    .vp-play{
      position: absolute;
      inset-inline-start: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 64px;
      height: 44px;
      border-radius: 12px;
      border: 1px solid rgba(255,255,255,.18);
      background: rgba(0,0,0,.35);
      color: rgba(255,255,255,.92);
      display: grid;
      place-items: center;
      cursor: pointer;
        z-index: 5;
        backdrop-filter: blur(8px);
        transition: transform .15s ease, background .15s ease, border-color .15s ease, opacity .15s ease;
      }
      
      .vp-play:hover{
        transform: translate(-50%, -50%) scale(1.05);
        background: rgba(0,0,0,.45);
        border-color: rgba(255,255,255,.28);
      }
      
      .vp-play:active{
        transform: translate(-50%, -50%) scale(.98);
      }
      
      .vp-play:focus-visible{
        outline: 2px solid rgba(45,212,255,.55);
        outline-offset: 3px;
      }
  }

  #video-player-id {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain; /* Keeps aspect ratio correct inside the 16/9 box */
  }
  
  .playBtn {
    width: 86px;
    height: 54px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(10, 16, 24, 0.55);
    display: grid;
    place-items: center;
    cursor: pointer;
    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.35);
  }
  
  .playBtn:hover {
    background: rgba(10, 16, 24, 0.7);
  }
  
  .playerFooter {
    padding: 10px;
    border-top: 1px solid var(--line);
    background: rgba(10, 16, 24, 0.55);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    font-size: 12px;
    color: var(--muted);
    display: flex;
    justify-content: flex-end;
  }
  
  .controls {
    display: flex;
    gap: 6px;
    align-items: center;
  }
  
  .chip {
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.03);
    padding: 6px 10px;
    border-radius: 12px;
    color: var(--muted);
    cursor: pointer;
    user-select: none;
  }
  
  .chip:hover {
    background: var(--hover);
    color: var(--text);
  }
  
  .quickMeta {
    margin-top: 10px;
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.02);
    border-radius: 14px;
    overflow: hidden;
  }
  
  .quickMeta .qmHead {
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border-bottom: 1px solid var(--line);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0));
  }
  
  .qmTitle {
    font-weight: 750;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 15px);
  }
  
  .qmGrid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 12px;
  }
  
  .kv {
    border: 1px solid var(--line);
    border-radius: 12px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.02);
    width: 100%;
    overflow-wrap: anywhere;
    text-align: start;
  }
  
  .kv .k {
    font-size: 11px;
    color: var(--muted);
  }
  
  .kv .v {
    font-size: 13px;
    margin-top: 4px;
    font-weight: 650;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  /* AI Panel Tabs */
  .tabs {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
  
  .tab {
    padding: 7px 10px;
    border-radius: 999px;
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.02);
    color: var(--muted);
    cursor: pointer;
    user-select: none;
    font-size: 12px;
    font-weight: 650;
  }
  
  .tab:hover {
    background: var(--hover);
    color: var(--text);
  }
  
  .tab.active {
    color: var(--accent);
    border-color: rgba(45, 212, 255, 0.28);
    background: rgba(45, 212, 255, 0.1);
  }
  
  .tabContent {
    margin-top: 10px;
  }
  
  /* Inputs */
  .formRow {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 12px;
  }
  
  .label {
    font-size: 12px;
    color: var(--muted);
  }
  
  .input, .textarea {
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.02);
    border-radius: 12px;
    padding: 10px 12px;
    color: var(--text);
    outline: none;
    font-size: 13px;
  }
  
  .textarea {
    min-height: 90px;
    resize: vertical;
    font-family: inherit;
  }
  
  .chipsWrap {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 10px;
  }
  
  .tag {
    padding: 6px 10px;
    border-radius: 999px;
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.02);
    font-size: 12px;
    color: var(--text);
    cursor: pointer;
    user-select: none;
  }
  
  .tag:hover {
    background: var(--hover);
  }
  
  .tag.ai {
    border-color: rgba(45, 212, 255, 0.25);
    background: rgba(45, 212, 255, 0.08);
    color: rgba(255, 255, 255, 0.92);
  }
  
  /* Transcript */
  .transcript {
    margin-top: 10px;
    border: 1px solid var(--line);
    border-radius: 14px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.02);
  }
  
  .transcript .tHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 12px;
    border-bottom: 1px solid var(--line);
    background: rgba(10, 16, 24, 0.45);
    position: sticky;
    top: 0;
    z-index: 3;
  }
  
  .tHead .left {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    color: var(--muted);
  }
  
  .tBody {
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    line-height: 1.45;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.88);
    max-height: calc(100vh - 250px);
    overflow: auto;
  }
  
  .line {
    padding: 10px 10px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.15);
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }
  
  .ts {
    font-variant-numeric: tabular-nums;
    color: var(--muted);
    min-width: 72px;
    font-size: 12px;
    margin-top: 1px;
  }
  
  .actions {
    margin-inline-start: auto;
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }
  
  .miniBtn {
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.02);
    padding: 6px 8px;
    border-radius: 10px;
    color: var(--muted);
    font-size: 12px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
  }
  
  .miniBtn:hover {
    background: var(--hover);
    color: var(--text);
  }
  
  .miniBtn.primary {
    border-color: rgba(45, 212, 255, 0.28);
    background: rgba(45, 212, 255, 0.08);
    color: var(--accent);
  }
  
  /* Cards */
  .cards {
    margin-top: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  
  .aiCard {
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.02);
    border-radius: 14px;
    padding: 12px;
  }
  
  .aiCard .h {
    font-weight: 750;
    font-size: 13px;
  }
  
  .aiCard .p {
    color: var(--muted);
    font-size: 12px;
    margin-top: 6px;
  }
  
  .meter {
    margin-top: 10px;
    height: 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.06);
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.08);
  }
  
  .meter > div {
    height: 100%;
    background: linear-gradient(90deg, rgba(45, 212, 255, 0.9), rgba(59, 130, 246, 0.9));
  }
  
  /* Faces */
  .faces {
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }
  
  .face {
    border: 1px solid var(--line);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.02);
    overflow: hidden;
    cursor: pointer;
  }
  
  .face .img {
    height: 64px;
    background: radial-gradient(60px 60px at 40% 40%, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.02)),
                linear-gradient(135deg, rgba(45, 212, 255, 0.16), rgba(255, 255, 255, 0.03));
  }
  
  .face .meta {
    padding: 8px 10px;
    font-size: 12px;
    color: var(--muted);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .face:hover {
    background: var(--hover);
  }
  
  /* Smart Subclips */
  .subclipList {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .subclipCard {
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.02);
    border-radius: 16px;
    overflow: hidden;
  }
  
  .subclipTop {
    display: flex;
    gap: 12px;
    padding: 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0));
    align-items: stretch;
  }
  
  .subThumb {
    width: 140px;
    height: 78px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    overflow: hidden;
    background: radial-gradient(140px 90px at 30% 30%, rgba(59, 130, 246, 0.2), rgba(0, 0, 0, 0.12)),
                linear-gradient(135deg, rgba(45, 212, 255, 0.18), rgba(255, 255, 255, 0.03));
    position: relative;
    flex: 0 0 auto;
  }
  
  .subThumb .miniBadge {
    position: absolute;
    inset-inline-start: 10px;
    top: 10px;
    padding: 4px 8px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.35);
    font-size: 11px;
    color: rgba(255, 255, 255, 0.88);
  }
  
  .subThumb .playOverlay {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.25));
  }
  
  .subThumb .playOverlay .pbtn {
    width: 42px;
    height: 32px;
    border-radius: 10px;
    display: grid;
    place-items: center;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(10, 16, 24, 0.55);
  }
  
  .subTopMid {
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .timePill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: max-content;
    padding: 6px 10px;
    border-radius: 10px;
    border: 1px solid rgba(45, 212, 255, 0.2);
    background: rgba(45, 212, 255, 0.1);
    color: rgba(255, 255, 255, 0.92);
    font-weight: 800;
    letter-spacing: 0.3px;
    font-variant-numeric: tabular-nums;
  }
  
  .subMetaRow {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
    color: var(--muted);
    font-size: 12px;
  }
  
  .pillSoft {
    padding: 6px 10px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.03);
    color: rgba(255, 255, 255, 0.86);
    font-weight: 700;
  }
  
  .subActions {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-end;
    flex: 0 0 auto;
  }
  
  .iconSquare {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.02);
    display: grid;
    place-items: center;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .iconSquare:hover {
    background: var(--hover);
    border-color: rgba(45, 212, 255, 0.2);
    color: var(--accent);
  }
  
  .subBody {
    padding: 12px 14px 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .subTitle {
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 0.1px;
    margin-top: 2px;
  }
  
  .subDesc {
    color: rgba(255, 255, 255, 0.78);
    font-size: 14px;
    line-height: 1.45;
  }
  
  .subPath {
    color: rgba(255, 151, 151, 0.85);
    font-weight: 700;
    font-size: 13px;
  }
  
  details.subDetails {
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    padding-top: 10px;
  }
  
  details.subDetails summary {
    list-style: none;
    cursor: pointer;
    color: var(--muted);
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 10px;
    user-select: none;
  }
  
  details.subDetails summary::-webkit-details-marker {
    display: none;
  }
  
  .chev {
    width: 18px;
    height: 18px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: grid;
    place-items: center;
    background: rgba(255, 255, 255, 0.02);
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
  }
  
  details[open] .chev {
    transform: rotate(90deg);
  }
  
  .subTranscript {
    margin-top: 10px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.18);
    padding: 10px 12px;
    color: rgba(255, 255, 255, 0.84);
    font-size: 13px;
    line-height: 1.45;
  }
  
  /* Focus Mode */
  .focusBadge {
    position: absolute;
    top: 10px;
    inset-inline-end: 10px;
    padding: 6px 10px;
    border-radius: 999px;
    border: 1px solid rgba(45, 212, 255, 0.25);
    background: rgba(45, 212, 255, 0.1);
    color: var(--accent);
    font-size: 12px;
    font-weight: 800;
    z-index: 10;
  }
  
  /* Scrollbars */
  .panelBody::-webkit-scrollbar,
  .tBody::-webkit-scrollbar {
    width: 3px;
  }
  
  .panelBody::-webkit-scrollbar-thumb,
  .tBody::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 999px;
    border: 2px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }
  
  .panelBody::-webkit-scrollbar-thumb:hover,
  .tBody::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.16);
  }
  
  /* Small screens fallback */
  @media (max-width: 1100px) {
    .split {
      grid-template-columns: 1fr !important;
      min-width: 0;
      gap: 10px;
    }
    .resizer {
      display: none;
    }
    .panel {
      min-width: 0;
    }
    .cards {
      grid-template-columns: 1fr;
    }
    .faces {
      grid-template-columns: repeat(3, 1fr);
    }
    .subThumb {
      width: 120px;
    }
  }

  .asset-meta-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }
  
  .asset-meta-item {
    display: inline-flex;
    align-items: center;
  }
  
  .asset-meta-item + .asset-meta-item::before {
    content: "•";
    margin-inline-end: 6px;
    color: #999;
  }

}
</style>

<style lang="scss" scoped>

  $border-color: 1px solid #272a34;
  $primary-background: #1a1e21;
  $secondary-background-color:#141923;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $secondary-border-color: 1px solid #2b2b2b;
  $row-border-color: #212121;
  $secondary-border-color:#767676;


  @mixin storage-image-styles {
    height: 18px !important;
    width: 16px !important;
    border-radius: 5px !important;
    object-fit: contain;
    margin: 3px;
  }


  .keyword-highlight-wrapper{
    text-align: start;
    margin-inline-start: 6px;
    margin-top: -24px;
    color: $dull-text-color;
    font-size: 11px;
  }

  .activeAsset,
  .activeMultipleAssets {
    border: 1px solid $row-border-color !important;
    background: $bg-color-on-hover;
    border-radius: 5px !important;
    td:first-child,
    th:first-child {
      border-radius: 10px 0 0 10px;
    }

    // Set border-radius on the top-right and bottom-right of the last table data on the table row
    td:last-child,
    th:last-child {
      border-radius: 0 10px 10px 0;
    }
    .thumbnail-data {
      float: inline-start;
      background: #1879e28c !important;
      position: relative;
      width: 102%;
      inset-inline-start: -4px;
      .svg-icons-display{
        inset-inline-end:0px;
        bottom:-1px;
      }
    }
  }


  // .thumbnail-view-ul{
  //   li:hover{
  //     border: $border-color;
  //     border-radius: 5px;
  //   }
  // }
  .thumbnail-view-ul {
    list-style-type: none;
    display: inline-flex;
    flex-wrap: wrap;
    padding: 0px;
    margin-top: 0px;
    width: 100%;
    padding-inline-start: 20px;
    justify-content: start;
    overflow: auto;
    li {
    display: inline-block;
      margin-inline-end: 10px;
      width: 174px;
      padding-inline-start: 5px;
      margin-top: 5px;
      height: 128px;
      .asset-thumbnail {
        height: 92px;
        width: 162px;
        border-radius: 7px;
        margin-top: 8px;
        //border:$border-color;
        position:relative;
        img {
          max-width: 100%;
          max-height: 100%;
          border-radius: 7px;
          object-fit: contain;
          border-radius: 7px;
        }
      }
      .thumbnail-data {
        text-align: center !important;
      }
    }
  }

  .activeAsset.active-list-view{
    color:$active-blue !important;
    .description-alignment{
      color:$active-blue !important;
    }
  }

  .active-list-view{
  .shortcut-actions-type-icons-wrapper{
      inset-inline-end:-8px !important;
      top:0px;
    }
  }

    .activeAsset.active-list-view .overWriteShortcutIconWrapper{
      visibility: visible !important;
    }
  .folder-view-ul {
    padding-top: 10px;
    margin-bottom: 10px;
    .folder-view-li {
      display: inline-flex !important;
      height: 52px !important;
      border: 1px solid #3a3a3a;
      border-radius: 6px;
      .folder-view {
        font-size: 30px;
      }
      .catalogs-data {
        margin-top: 15px;
        margin-inline-start: 7px;
        width: 118px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: start;
      }
    }
  }

  .folder-view-li:hover{
    border: 1px solid $secondary-border-color !important;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 3px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

  .folder-view-ul {
    padding-top: 10px;
    margin-bottom: 10px;
    .folder-view-li {
      display: inline-flex !important;
      height: 52px !important;
      border: $border-color;
      border-radius: 6px;
      .folder-view {
        font-size: 30px;
      }
      .folder-data {
        margin-top: 15px;
        margin-inline-start: 7px;
        width: 118px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: start;
      }
    }
  }
  .reduce-opacity{
    opacity: 0.5 !important;
  }

  ::v-deep {
  .view-tags {
    font-size: 12px !important;
    min-height: 26px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border: $border-color;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 4px !important;
    text-align: center;
    width: auto !important;
    justify-content: center;
    span {
      padding: 0px 8px !important;
      margin-inline-start: 0px !important;
      font-size: 12px !important;
      border-radius: 15px !important;
      position: relative !important;
      top: 1px !important;
    }
  }
  font[color~=OrangeRed] {
      color: $highlight-font-color !important;
  }
  .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 2px !important;
    text-align: center;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 0px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 10px !important;
    margin-inline-end: 0px;
    margin-top: 1px;
    float: inline-end;
    margin-inline-start: 5px;
    position: relative;
    top:1px !important;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    min-width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display:none;
  }
  .VuePagination__pagination-item-next-chunk{
    display:none;
  }

  .VuePagination__pagination-item-prev-page{
    width:60px !important;
  }

  .VuePagination__pagination-item-next-page{
    width:60px !important;
  }

  .VuePagination__pagination-item-next-page a:before{
    width:60px;
  content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after{
    width:60px;
  content: " prev";
  }
  .v-list{
    padding:0px !important;
  }
  .v-list-item{
    text-align: start;
    border: $border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title{
          font-size: 14px !important;
          color:$text-color !important;
    }
  }
  .v-menu__content{
    width:225px !important;
    z-index: 9999 !important;
    overflow:auto;
    max-height:75vh !important;
  }
  // for multiselect

  div[data-drag-box-component]{
        z-index:100;
    }
  }


  .icon-background-on-hover:hover{
    background: #d1d2d31a;
  }

  .icon-background-on-hover{
    padding: 6px;
    height: 28px;
    width: 28px;
    border-radius: 4px;
  }

  .activeCatalog, .activeCatalog:hover {
    border: 2px solid $active-blue !important;
    border-radius: 5px !important;
    .thumbnail-data {
      background: #1879e28c !important;
      position: relative;
      width: 102%;
      inset-inline-start: -4px;
      .svg-icons-display {
        inset-inline-end: 0px;
        bottom: -1px;
      }
    }
    .folder-view {
      svg {
        color: $active-blue !important;
      }
    }
  }

  ::v-deep {
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }

  .theme--dark.v-list{
  background: #12171e !important;
  }

  .vmenuOnHover .v-list-item:hover .v-list-item__title{
              color:#fdfff4!important;
  }
  .vmenuOnHover{
      padding:0px !important;
      font-size: 14px!important;
      border: 1px solid #757575;
      background: #15181b !important;
    .v-list-item{
      text-align: start;
      min-height: 37px !important;
      padding: 0 10px !important;
      font-size: 12px !important;
      border: 1px solid #2b2b2b !important;
        .v-list-item__title{
              font-size: 14px !important;
              color:#eee !important;
        }
      }
    .v-menu__content{
      width:225px !important;
      z-index: 9999 !important;
    }
  }
  }


  .table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  margin: 0px 15px;
  thead {
    color: $dull-text-color !important;
    position: relative;
    width: 100%;
    th {
      position: sticky;
      top: 0;
      background: $primary-background;
      z-index: 9;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr {
      min-height: 60px;
      height: auto;
    }
  }
  }

  .table-cell-styles{
  th{
    border-top:none !important;
  }
  td{
    border-top:none !important;
    padding:10px;
  }
  }

  .table-with-border {
  thead {
    border-bottom: $border-color;
  }
  tr {
    border-bottom: $border-color;
  }
  }


  input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block;
  width: 22px;
  height: 21px;
  margin-top: -1px;
  margin-inline-start: -1px;
  border: $border-color;
  border-radius: 0.25em;
  background: $primary-background;
  }

  input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
  }
  .asset-thumbnail-hw-set{
  // height:68px;
  height:78px;
  width:130px;
  border-radius: 7px;
  // margin-bottom:10px;
  //border: $border-color;
  .thumbnail-hw-set{
    height:100%;
    position: relative;
    align-items: center;
    display: inline-flex;
    justify-content:center;
    width:100%;
    img{
      // height:100%;
      // width:100%;
      // border-radius: 7px;
      // object-fit:cover;

      max-width: 100%;
      max-height: 100%;
      border-radius: 7px;
      object-fit: contain;
      border-radius: 7px;
    }
  }
  }

  .assets-view-wrapper {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
  width: 100%;
  }

  .list-view-wrapper{
  height: 87% !important;
  width: 100%;
  }

  .thumbnail-data{
  svg{
      border-radius: 5px;
      height:100%;
      width:100%;
    }
  }
  .svg-icons-display{
    height: 20px;
    width: 20px;
    position: relative;
    opacity:0.8;
    inset-inline-end: 5px;
  }

  .file-name{
    white-space: nowrap;
      width: 81%;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: initial;
      position: relative;
      inset-inline-start: 2px;
      top: 2px;
  }

  .storage-type-icons-wrapper,.storage-type-icons-wrapper-list-view{
  position: absolute;
  svg.img{
    margin:3px;
  }
  }

  .storage-type-icons-wrapper-list-view{
  color: $dull-text-color;
  inset-inline-end: 0px;
  img{
      @include storage-image-styles;
  }
  svg{
      margin:3px;
    }
  }

  .storage-type-icons-wrapper{
    color: #999;
    background: #1a1a1ab3;
    min-width: 30px;
    width: auto;
    inset-inline-end: -2px;
    bottom: -2px;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    display:flex;
    justify-content: center;
    img{
      @include storage-image-styles;
    }
    svg{
      margin:3px;
    }
  }
  .shortcut-actions-type-icons-wrapper{
        visibility: hidden;
        color: #999;
        background: #08101c;
        min-width: 30px;
        width: auto;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        position: absolute;
        top: 6px;
        inset-inline-end: 6px;
        line-height: 1;
        margin-inline-start: 8px;
        border: unset;
        --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
        box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
        display: flex;
        padding: 2px;
        border-radius: 0.375em;
        svg{
            margin-inline-start: 6px;
            margin-inline-end: 6px;
        }
    }
    .asset-thumbnail:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
          
        }
    }
    .overflow-parent-div {
      .overflow-menu{
        background: #1e1e1e;
        font-size: 14px !important;
        border: 1px solid #757575;
        top: 19px;
        display: inline-block;
        inset-inline-start: calc(100% - 25px);
        padding-top: 3px !important;
        // visibility: hidden;
      }
    }
  
    .asset-thumbnail-hw-set:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
        }
    }
    .shortcut-actions-type-icons-wrapper svg:hover{
        fill: #fdfff4;
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action:hover{
        color: #fdfff4 !important;
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action{
        color: #a3adad !important;
    }
    .activeCatalog .overWriteShortcutIconWrapper{
      visibility: visible !important;
    }
    .hover-context-menu-action{
      align-items: center;
      font-size: 14px !important;
      .svg-hover-context-menu-icon{
        float: inline-start;
        width: 20px;
        height: 20px;
      }
    }
  .file-name-display-styles-in-list-view{
  white-space: nowrap;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: initial;
    position: absolute;
  }

  .comm-lengthy-value-styles{
  white-space: normal;
    // max-width: 80%;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // text-align: initial;
    // position: relative;
    // inset-inline-start :-2px;
    // top: 2px;
    word-break: break-all;
  }

    .dropdown-menu{
      background-color:$secondary-background-color !important;
      border: $border-color;
      .dropdown-item{
      color:$text-color;
      font-size:14px !important; 
      }
  }

  .dropdown-item:hover{
      background-color:$bg-color-on-hover !important;
  }
  .nav-item{
      color: $secondary-text-color !important;
  }

  .dropdown-toggle:after{
    display:none !important;
  }

  .dull-the-text{
    color: $secondary-text-color;
  }
  // .dull-the-text:hover{
  //   color: #1d9bd1;
  //   text-decoration: underline;;
  // }

  .secondary-dull-the-text{
    color: $secondary-text-color;
    white-space: pre-wrap;
  }
  .description-alignment{
    position:relative;
    top:2px;
  }
  .change-the-text-color{
    color: $dull-text-color;
    text-transform: uppercase;
    height: 22px;
    width: fit-content;
    border: 1px solid #F49D1A;
    border-radius: 10px;
    padding: 3px 9px;
    color: #F49D1A;
    font-size: 10px;
    letter-spacing: 0.5px;
  }

  .thumbnail-view-resolution-label{
    color: #eee;
    position: absolute;
    top: 0px;
    inset-inline-start: 0px;
    font-size: 10px;
    padding: 1px 5px;
    justify-content: center;
    display: flex;
    border-radius: 7px;
    align-items: center;
    margin: 2px;
  }

  .bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
  }
  .bigger-checkboxes:focus{
  box-shadow: unset;
  }

  input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
  }
  input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
  }

  .res-FHD{
  // background: rgba(248, 120, 0, 0.6) !important;
  background: #f87800 !important;
  border: 1px solid #4a4a4a;
  }
  .res-fourK{
  background: #f8090199 !important;
  border: 1px solid #4a4a4a;
  //background: rgba(248, 9, 1, 0.6) !important;
  }
  .res-HD{
  // background: rgba(245, 241, 4, 0.6) !important;
  background: #f5f10499 !important;
  border: 1px solid #4a4a4a;
  color: #292a2b !important;
  }
  .res-SD{
  // background: rgba(29, 134, 140, 0.952) !important;
  background: #1d868cf3 !important;
  border: 1px solid #4a4a4a;
  }
  .photo-album-svg{
  height: 12px !important;
  width: 17px !important;
  inset-inline-end: 2px;
  position: absolute;  
  border-radius: 10px;
  background: transparent;
  top:6px;
  fill: #1a1e21;
  }
  .display-label{
  height: 22px;
  width: fit-content;
  border: 1px solid #F49D1A;
  border-radius: 10px;
  padding: 3px 9px;
  color: #F49D1A;
  font-size: 10px;
  letter-spacing: 0.5px;
  }
  .asset-thumbnail-hw-set.svg-as-thumbnail,.asset-thumbnail.svg-as-thumbnail{
  border: unset !important;
  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%);
  }

  .file-extension{
  margin-inline-start: 5px;
  color: #aba7a7 !important;
  margin-top:2px
  }
  .file-extension-thumbnail-view{
  min-width: 51px;
  margin-inline-start: 5px;
  color: #aba7a7 !important;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  }
  .dynamic-slug-name{
  margin-top:2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  }

  .multi-transcript-content-wrapper{
  display: flex;
  width: 100%;
  align-items: flex-start;
  margin-top: 11px;
  position: relative;
  flex-wrap: wrap;
  .transcript-list{
    display:inline-flex;
    width: 100%;
    margin-bottom:4px;
    svg{
      margin-inline-end: 2px;
    }
    svg:hover{
      fill:#eee;
    }
  }
  }
  .common-media-in-out-display{
  font-size: 14px;
  background: rgb(52, 52, 52);
  padding: 4px 5px; 
  justify-content: start; 
  display: flex; 
  border-radius: 3px;
  color: rgb(238, 238, 238) !important;
  gap:3px;
  height:28px;
  }

  video{
    height:100% !important;
    width:100% !important;
    outline: unset !important;
  }
  ::v-deep{
    .playerWrap{
      .vjs_video_3-dimensions, .video-js{
          height:300px !important;
          width:100% !important;
      }
      .video-js{
          height:300px !important;
          width:100% !important;
      }
    }
    .vjs-sub-clip-marker
    {
      position: absolute;
      background: #ea4863;
      width: 3px;
      height: 18px;
      top: -7px;
      z-index: 30;
      margin-inline-start: -3px;
      border-radius: 3px;
      font-size: 14px;
      font-family: "Roboto", Arial, sans-serif !important;
    }
    .sub-clip-markin-markout-play .vjs-control-bar{
      display: flex !important;
      opacity:1 !important;
    }

    .vjs-control-bar{
        display: flex !important;
        opacity:1 !important;
    }

      .player-current-time-division{
        width: auto !important;
        font-size: 9px !important;
        .currrent-time , .full-time-of-time-division{
          min-width: unset !important;
        }
    }

  .sub-clip-markin-markout-play .video-js .vjs-play-progress {
      background-color: #28cfd8;
    }
    .sub-clip-markin-markout-play .video-js .vjs-play-progress:before {
      font-size: 1.8em!important;
      z-index: 99!important;
      top: -0.43333333333em;
      color: #28cfd8;
    }
    .audio-player{
      position: absolute;
      bottom: 0px;
      width: 100%;
      height: 26px;
      inset-inline-start:0px;
    }

  }

  /* Ensure your absolute icons (3-dots / error / gif) align correctly */
  .mv-album-thumb{
    position: relative;
    width: 110px;
  }

  /* Improve the card look without touching your logic */
  .mv-album-thumb .card{
    border-radius: 12px !important;
    border: 1px solid rgba(255,255,255,.10) !important;
    background: rgba(255,255,255,.04) !important;
    overflow: hidden !important;
    position: relative !important;
    transition: transform .15s ease, border-color .15s ease, background .15s ease;
  }

  .mv-album-thumb .card:hover{
    transform: translateY(-2px);
    border-color: rgba(255,255,255,.18) !important;
    background: rgba(255,255,255,.06) !important;
  }

  /* Image stays full cover */
  .mv-album-thumb .card-img-top{
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    display: block !important;
  }

  /* Upgrade the bottom overlay to a clean gradient */
  .mv-album-thumb .mv-card-body.album-overlay{
    inset-inline-start: 0; inset-inline-end :0; bottom: 0;
    width: 100% !important;
    padding: 8px 8px 9px !important;
    background: linear-gradient(to top, rgba(0,0,0,.72), rgba(0,0,0,.25)) !important;
    backdrop-filter: blur(6px);
    border-radius: 0 0 12px 12px !important;
  }

  /* Title styling (your highlight logic stays) */
  .mv-album-thumb .mv-card-body .transcript-content-wrapper,
  .mv-album-thumb .mv-card-body > div > div > div:first-child{
    color: rgba(255,255,255,.92);
    font-size: 13px;
    font-weight: 650;
    line-height: 1.1;
  }

  /* Make long names behave nicely */
  .mv-album-thumb .mv-card-body [title]{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Meta section: make it compact instead of tall */
  .mv-album-thumb .mv-card-body div[style*="font-size: 11px"]{
    margin-top: 6px;
    color: rgba(255,255,255,.65) !important;
    font-size: 11px !important;
    display: flex !important;
    flex-direction: row !important;   /* overrides your column look */
    gap: 6px;
    align-items: center;
  }

  /* Your count/date divs: keep them but align in one line */
  .mv-album-thumb .mv-card-body div[style*="font-size: 11px"] > div{
    width: auto !important; /* overrides width:50% so it won’t look cramped */
    max-width: 100%;
  }

  /* Add a dot between count and date WITHOUT removing anything */
  .mv-album-thumb .mv-card-body div[style*="font-size: 11px"] > div:first-child::after{
    content: " •";
    margin-inline-start: 2px;
    color: rgba(255,255,255,.45);
  }

  /* Make 3-dots cleaner + better hover */
  .mv-album-thumb .bi-three-dots-vertical{
    opacity: .85;
    transition: opacity .15s ease, transform .15s ease;
  }
  .mv-album-thumb .bi-three-dots-vertical:hover{
    opacity: 1;
    transform: scale(1.05);
  }

  /* Ensure your status icons stay above overlay */
  .mv-album-thumb .shortcut-actions-type-icons-wrapper{
    position: absolute;
    top: 6px;
    inset-inline-end: 6px;
    z-index: 5 !important;
  }

  /* Your growing/error/delete icons */
  .mv-album-thumb img[alt="loading"],
  .mv-album-thumb svg[viewBox="0 0 16 16"],
  .mv-album-thumb img[alt="markfordelete"]{
    z-index: 6 !important;
  }

  .empty-state{
    min-height: 180px;
    width: 100%;
    display: grid;
    place-content: center;
    text-align: center;
    padding: 18px;
    gap: 8px;
  }

  .empty-icon{
    width: 44px;
    height: 44px;
    margin: 0 auto 4px;
    display: grid;
    place-items: center;

    border-radius: 14px;
    color: rgba(255,255,255,.85);
    border: 1px solid rgba(255,255,255,.12);
    background: rgba(0,0,0,.22);
    backdrop-filter: blur(8px);
  }

  .empty-title{
    font-size: 14px;
    font-weight: 650;
    color: rgba(255,255,255,.92);
  }

  .empty-sub{
    font-size: 12px;
    color: rgba(255,255,255,.60);
    max-width: 360px;
  }

  .empty-btn{
    margin: 8px auto 0;
    padding: 8px 12px;
    border-radius: 12px;
    border: 1px solid rgba(255,255,255,.14);
    background: rgba(0,0,0,.30);
    color: rgba(255,255,255,.90);
    cursor: pointer;
  }
  .empty-btn:hover{ background: rgba(0,0,0,.40); }
  .empty-btn:focus-visible{
    outline: 2px solid rgba(45,212,255,.55);
    outline-offset: 3px;
  }

  .preview-the-image{
    position: absolute;
    bottom: 9px;
    inset-inline-end: 11px;
    height: 25px;
    width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #00000057;
    border-radius: 3px;
  }

  .metadata_view_main_window_palyer_icons_wrapper{
    align-items: center;
    display: flex;
    //height: 100%;
    margin-inline-start: 4px;
    width: 91%;
    justify-content: space-between;
    ul{
      display: inline-flex;
      margin-bottom: 0px !important;
      margin-inline-start: 2px;
      height: 100%;
      li{
        display: inline-flex;
        margin-inline-end: 5px;
        padding: 0px !important;
        color: #bcbcbc;;
      }
    }
    button{
        font-size: 13px;
        width: 37px !important; 
        justify-content: center; 
        display: flex; 
        align-items: center; 
        height: 25px;
        border: none !important;
    }
    .fast-forward-div, .fast-backward-div{
        display: inline-flex;
        border:1px solid #6c757d;
        color: #bcbcbc;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-inline-end: 6px;
        svg{
          margin-top:0px;
          width:20px;
          height:20px;
          margin-inline-end: 5px;
          fill: #6c757d;
        }
    }
    .fast-forward-div:hover, .fast-backward-div:hover{
      background-color: #6c757d;
      border-color: #4a4a4a;
      svg{
        fill: #eee;
      }
    }  

    .active-speed{
      border-color: $active-blue;
      color: $active-blue;
    }

    .active-speed:hover{
      color:#eee !important;
    }  
  }

  .qmTitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .qmTitle.expandedFileName {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    word-break: break-word;
  }

  .qmHead {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .qmHead:hover{
    .copyFileNameBtn{
      visibility: visible;
    }
  }

  .qmTitle {
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: text;
    user-select: text;
  }

  .copyFileNameBtn {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 4px;
    cursor: pointer;
    visibility: hidden;
  }

  .copyFileNameBtn:hover {
    svg{
      fill: #fff;
    }
  }

  .metadata-view-configured-columns-row {
    margin-top: 6px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start !important;
    gap: 6px;
    max-width: 100%;
    overflow: visible !important;
  }

  .metadata-view-configured-column-chip {
    display: inline-flex;
    align-items: flex-start !important;
    max-width: 100% !important;
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, 0.04);
    border-radius: 10px;
    padding: 3px 7px;
    font-size: 11px;
    color: var(--muted);
    gap: 4px;
  }

  .metadata-view-configured-column-name {
    color: var(--muted);
    flex: 0 0 auto !important;
    white-space: nowrap !important;
  }

  .metadata-view-configured-column-value {
    color: var(--text);
    min-width: 0 !important;
    max-width: 160px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .metadata-view-configured-column-chip--multiline,
  .fusion-metadata-view-root .metadata-view-configured-column-chip--freetext-multivalue {
    display: inline-flex !important;
    align-items: flex-start !important;
    min-width: 0 !important;
    max-width: 100% !important;
  }

  .metadata-view-configured-column-chip--multiline {
    flex: 1 1 320px !important;
  }

  .fusion-metadata-view-root .metadata-view-configured-column-chip--freetext-multivalue {
    flex: 1 1 100% !important;
    width: 100% !important;
    flex-direction: column !important;
    justify-content: flex-start !important;
    gap: 2px !important;
    padding: 4px 8px !important;
    white-space: normal !important;
    overflow: visible !important;
    box-sizing: border-box !important;
  }

  .fusion-metadata-view-root .metadata-view-configured-column-chip--freetext-multivalue .metadata-view-configured-column-name,
  .fusion-metadata-view-root .metadata-view-configured-column-chip--freetext-multivalue .metadata-view-configured-column-value {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    text-align: start !important;
  }

  .metadata-view-multiline-wrapper,
  .fusion-metadata-view-root .metadata-view-configured-column-chip--freetext-multivalue .metadata-view-multiline-wrapper {
    display: flex !important;
    flex-direction: column !important;
    flex: 1 1 auto !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
  }

  .metadata-view-multiline-value,
  .fusion-metadata-view-root .metadata-view-configured-column-chip--freetext-multivalue .metadata-view-configured-column-value {
    display: -webkit-box !important;
    width: 100% !important;
    max-width: 100% !important;
    max-height: 34px !important;
    white-space: pre-wrap !important;
    word-break: break-word !important;
    overflow-wrap: anywhere !important;
    overflow: hidden !important;
    text-overflow: unset !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    color: var(--text) !important;
    line-height: 17px !important;
  }

  .metadata-view-multiline-value.expanded,
  .fusion-metadata-view-root .metadata-view-configured-column-chip--freetext-multivalue .metadata-view-configured-column-value.expanded {
    display: block !important;
    -webkit-line-clamp: unset !important;
    -webkit-box-orient: unset !important;
    max-height: none !important;
    height: auto !important;
    overflow: visible !important;
    text-overflow: unset !important;
    white-space: pre-wrap !important;
    word-break: break-word !important;
    overflow-wrap: anywhere !important;
  }

  .metadata-view-show-more-btn {
    position: relative !important;
    z-index: 5 !important;
    pointer-events: auto !important;
    display: inline-flex !important;
    width: fit-content !important;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    margin: 2px 0 0 0 !important;
    color: #a6a6a6 !important;
    font-size: 11px !important;
    line-height: 14px !important;
    cursor: pointer !important;
  }

  .metadata-view-show-more-btn:hover {
    text-decoration: underline !important;
  }
</style>